// @ts-ignore
/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A field whose value is a Currency: https://en.wikipedia.org/wiki/ISO_4217. */
  Currency: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** Integers that will have a value greater than 0. */
  PositiveInt: any;
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: any;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: any;
};



export type AccountMenu = {
  __typename?: 'AccountMenu';
  loggedInMenu: Array<AccountMenuItem>;
  loggedOutMenu: Array<AccountMenuItem>;
};

export type AccountMenuItem = {
  __typename?: 'AccountMenuItem';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type AddAddressInput = {
  company?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  streetAddress: Scalars['String'];
  streetAddress2?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  stateShort?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  deliveryLocationType: DeliveryLocationType;
  /** The location name. Only used for click and collect and parcel lockers. Eg Kmart, Target, Richmond LPO */
  deliveryLocationName?: Maybe<Scalars['String']>;
  /** Set as primary/default address */
  defaultAddress: Scalars['Boolean'];
};

export type AddAddressResponse = Customer | UserError;

/** Add item to wishlist input */
export type AddItemToWishlistInput = {
  /** VariantId for the product being added to the wishlist */
  variantId: Scalars['ID'];
  /** Enables the user to be notified if product comes back in stock */
  notify?: Maybe<Scalars['Boolean']>;
};

export type AddItemsToCartInput = {
  items: Array<AddToCartInput>;
};

/** Add item to cart */
export type AddToCartInput = {
  eventId?: Maybe<Scalars['Int']>;
  shopSlug?: Maybe<Scalars['String']>;
  offerId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourcePosition?: Maybe<Scalars['Int']>;
  sourcePlatform?: Maybe<SourcePlatformType>;
  trigger?: Maybe<Trigger>;
  /** only use this for personalised product, e.g gift card */
  personalisedValues?: Maybe<Array<PersonalisedValueInput>>;
};

/** Address */
export type Address = {
  __typename?: 'Address';
  id: Scalars['ID'];
  company?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  streetAddress: Scalars['String'];
  streetAddress2?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  stateShort?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  deliveryLocationType: DeliveryLocationType;
  /** The location name. Only used for click and collect and parcel lockers. Eg Kmart, Target, Richmond LPO */
  deliveryLocationName?: Maybe<Scalars['String']>;
};

/**
 * Address book
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type AddressBook = {
  __typename?: 'AddressBook';
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  defaultAddress?: Maybe<Address>;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  addresses: Array<Address>;
};

export type AnalyticVendorConfiguration = {
  enabled?: Maybe<Scalars['Boolean']>;
};

/** Namespace for all frontend analytics configuration */
export type Analytics = {
  __typename?: 'Analytics';
  snowplow: SnowplowConfiguration;
  gtm: GtmConfiguration;
  branchio: BranchIoConfiguration;
};


/** Namespace for all frontend analytics configuration */
export type AnalyticsSnowplowArgs = {
  input?: Maybe<SnowplowConfigurationInput>;
};

/**
 * A link for an app download from OS' app store
 * 
 * `owner(tribe: "CAL", squad: "LS")`
 */
export type AppDownloadLink = {
  __typename?: 'AppDownloadLink';
  /**
   * The name/identifier of the app store
   * 
   * `owner(tribe: "CAL", squad: "LS")`
   */
  name: Scalars['String'];
  /**
   * URL of the link
   * 
   * `owner(tribe: "CAL", squad: "LS")`
   */
  url: Scalars['String'];
};

/**
 * Banners are generally a page-wide image scheduled and typically links to another page either on the Catch website or externally.
 * Banners contain information such as title, subtitle, as well other generic high level data use to describe itself.
 * 
 *     `owner(tribe: "Digital", squad: "search-and-discover")`
 */
export type Banner = {
  __typename?: 'Banner';
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  id: Scalars['ID'];
  /**
   * The URL the banner links to.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  url?: Maybe<Scalars['URL']>;
  /**
   * Event banner image.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  image: Image;
  /**
   * This field is to be populated when an Event only has one product associated with it.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  platforms: Array<Platform>;
};

export type BannerByPageInput = {
  page?: Maybe<BannerPageType>;
};

export type BannerByPageResponse = {
  __typename?: 'BannerByPageResponse';
  banners: Array<Banner>;
};

export type BannerPageType = 
  | 'PRODUCT'
  | 'SEARCH';

/** Response for deleting the customer */
export type BooleanResponse = {
  __typename?: 'BooleanResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

/** Configuration used to connect to BranchIO */
export type BranchIoConfiguration = AnalyticVendorConfiguration & {
  __typename?: 'BranchIOConfiguration';
  enabled: Scalars['Boolean'];
  bannerApiKey: Scalars['String'];
};

/**
 * Information for a specified brand, note that the name is a text value which can be created by sellers as required, meaning the data is not normalised.
 * 
 * `owner(tribe: "Digital", squad: "search-and-discover")`
 */
export type Brand = {
  __typename?: 'Brand';
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  id: Scalars['ID'];
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  name: Scalars['String'];
  /**
   * Human readable unique string, generally used for resource location (URL).
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  slug: Scalars['String'];
  /**
   * The description of the brand in HTML.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  description?: Maybe<Scalars['String']>;
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  seoContent: SeoContent;
};

export type BrandByIdInput = {
  id: Scalars['ID'];
};

export type BrandRecommendedProductsInput = {
  productIds: Array<Scalars['ID']>;
  inStock?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
};

export type BrandRecommendedProductsResponse = {
  __typename?: 'BrandRecommendedProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
};

/** Namespace for CMS configuration */
export type CmsConfiguration = {
  __typename?: 'CMSConfiguration';
  header: HeaderConfiguration;
  /** Frontend analytics configuration */
  analytics: Analytics;
};


/** Namespace for CMS configuration */
export type CmsConfigurationHeaderArgs = {
  input?: Maybe<HeaderConfigurationInput>;
};

/** Cart information for the current context user */
export type Cart = {
  __typename?: 'Cart';
  /** Identifier to assist data normalisation within Apollo cache */
  id: Scalars['ID'];
  /** Logical groupings within the cart */
  parcels: Array<CartParcel>;
  /** Informative messages or errors for the customer at the cart level (displayed at top) */
  notices: Array<CartNotice>;
  /** Information about pricing details of the overall cart */
  orderSummary: CartOrderSummary;
  /** Sum of item quantities inside cart (for use in Mini Cart) */
  itemsQuantitySum: Scalars['Int'];
  /** A manually applied coupon, if one has been applied to the cart */
  userCoupon?: Maybe<CartCoupon>;
  /** All details of the Club Catch subscription item to display in cart */
  clubSubscription: CartClubSubscription;
  /**
   * Selected shipping option
   * @deprecated Only for use by legacy iOS cart
   */
  selectedShippingOption?: Maybe<CartParcelShippingOption>;
  /**
   * List of shipping options on the cart
   * @deprecated Only for use by legacy iOS cart
   */
  shippingOptions: Array<CartParcelShippingOption>;
  /**
   * Information about pricing details of the cart exclude giftcard, and roundup
   * @deprecated Only for use by legacy iOS cart
   */
  legacyOrderSummary: LegacyCartOrderSummary;
  canProceedToCheckout: Scalars['Boolean'];
  /** Current selected cart shipping location. If location has not previously been specified, it will be inferred from either customer default address or geolocation */
  shippingLocation?: Maybe<CartShippingLocation>;
  /**
   * Fingerprint is a unique hash for the current state of the cart. If price, quantity, shipping costs or club catch status change, the hash will change
   * This is useful to detect if the cart has been updated on a different device, tab or window.
   * It is the responsibility of the client to monitor for changes to the fingerprint and display whatever notice may be appropriate to the customer.
   */
  fingerprint: Scalars['String'];
  /** Flags whether the cart is on a sales channel that supports gift card payments */
  giftCardSupported: Scalars['Boolean'];
  /** Flags whether the OnePass popup recommender should be displayed */
  showOnePassRecommender: Scalars['Boolean'];
};

/** Response for mutations that involve multiple items */
export type CartBatchMutationResponse = {
  __typename?: 'CartBatchMutationResponse';
  cart: Cart;
  errors: Array<Error>;
};

/**
 * Club Catch subscription item to display in the Cart
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type CartClubSubscription = {
  __typename?: 'CartClubSubscription';
  /**
   * All the club subscription options the user can select
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  options: Array<CartClubSubscriptionOption>;
  /**
   * The current chosen option selected by the user
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  selectedOption?: Maybe<CartClubSubscriptionOption>;
  /**
   * Cart ID
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  id?: Maybe<Scalars['ID']>;
  /**
   * Whether to offer Club Catch upsell within the delivery box
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   * @deprecated Only for use by legacy iOS cart
   */
  offerUpsell: Scalars['Boolean'];
};

export type CartClubSubscriptionOption = ClubSubscription & {
  __typename?: 'CartClubSubscriptionOption';
  /** A unique id for each club subscription; maps 1-1 with offer.id */
  id: Scalars['ID'];
  /** Price of the monthly or yearly subscription */
  price: Money;
  /** Billing interval */
  interval: ClubSubscriptionInterval;
  /** The Date the user will next be billed */
  nextBillingDate: Scalars['DateTime'];
  /** Whether or not the option is a free trial */
  freeTrial: Scalars['Boolean'];
  /** Title to display on the item */
  title: Scalars['String'];
  /** Subtitle including cost and expiry date */
  subtitle: Scalars['String'];
  /** The image to display in the parcel item */
  clubImage: Image;
};

/** A coupon applied to the Cart */
export type CartCoupon = {
  __typename?: 'CartCoupon';
  /** The coupon object as entered by the customer */
  coupon: CartCouponMetadata;
  /** Handles coupon validity */
  notices: Array<CartNotice>;
};

/** The code for a CartCoupon */
export type CartCouponMetadata = {
  __typename?: 'CartCouponMetadata';
  /** The coupon code as entered by the customer, e.g. 15CASHOFF */
  code: Scalars['String'];
};

/** Generic error type returned by Cart batch mutations */
export type CartItemError = Error & {
  __typename?: 'CartItemError';
  offerId: Scalars['ID'];
  message: Scalars['String'];
};

/** Response for mutations that only involve one item */
export type CartMutationResponse = Cart | UserError | UnauthorisedUserError;

/** A notice attached to a Cart, CartParcel or CartParcelItem */
export type CartNotice = {
  __typename?: 'CartNotice';
  /** Text details of the cart notice, eg: 'This offer has expired.' */
  message: TemplateString;
  /** Type of the notice, eg: 'ERROR', 'INFO' */
  type: CartNoticeType;
  /** If the notice is advisory, checkout can still occur (meaning the notice is non blocking) */
  advisory: Scalars['Boolean'];
};

/** CartNoticeType is used to determine the colour to display on the frontend and whether the notice blocks checkout */
export type CartNoticeType = 
  | 'ERROR'
  | 'WARNING'
  | 'INFO';

/**
 * A summary of the customer's order. Includes the cost of items, delivery charges and more.
 * Supports both web and iOS requirements.
 */
export type CartOrderSummary = {
  __typename?: 'CartOrderSummary';
  /** Identifier to assist data normalisation within Apollo cache */
  id: Scalars['ID'];
  /** Items displayed as costs to the customer */
  itemSummary: OrderSummaryItems;
  /** Cost and type of delivery */
  delivery?: Maybe<OrderSummaryDelivery>;
  /** Details of the current charity, customers can donate by rounding up to the nearest dollar. */
  donation?: Maybe<OrderSummaryDonation>;
  /** Show applied gift cards */
  giftCards: Array<OrderSummaryGiftCard>;
  /** Show applied discounts such as coupons or club catch free shipping */
  discounts: Array<OrderSummaryDiscount>;
  /** Store credit */
  storeCredit?: Maybe<StoreCreditSummary>;
  /**
   * Determines whether customer needs to verify their age for order submission.
   * This value is derived from the `ageRestricted` field.
   */
  ageConfirmationRequired?: Maybe<Scalars['Boolean']>;
  /** Subtotal derived from all items in each cart group */
  subtotalPrice: Money;
  /** Final total cost to the customer */
  totalPrice: Money;
  /** Total amount saved on RRP */
  totalSaving: Money;
};

/** A collection of items in a Cart to be shipped to the user from the same seller */
export type CartParcel = {
  __typename?: 'CartParcel';
  /** UUID of the grouping, determined by grouping metadata */
  id: Scalars['ID'];
  /** Name of the seller for the items in this parcel */
  sellerName: Scalars['String'];
  /** If this parcel is from a Marketplace seller */
  marketplaceSeller: Scalars['Boolean'];
  /** Line items within the group */
  items: Array<CartParcelItem>;
  /** Information about parcel dispatch such as dispatch type and expected date range */
  dispatchNotice?: Maybe<CartParcelDispatchNotice>;
  /** Selected shipping option */
  selectedShippingOption?: Maybe<CartParcelShippingOption>;
  /** List of shipping options on the cart group */
  shippingOptions: Array<CartParcelShippingOption>;
  /**
   * The total price of all the line items within the group
   * @deprecated Only for use by legacy iOS cart
   */
  subtotalPrice: Money;
  /**
   * Total amount of discounts provided by Club Catch, if applicable
   * @deprecated Only for use by legacy iOS cart
   */
  clubDiscountPrice: Money;
  /**
   * Informative message regarding Club Catch eligibility for this parcel
   * @deprecated Only for use by legacy iOS cart
   */
  clubDiscountMessage: Scalars['String'];
  /** Is this parcel eligible for a club membership up sell? */
  clubUpsellEligible: Scalars['Boolean'];
};

export type CartParcelDispatchNotice = {
  __typename?: 'CartParcelDispatchNotice';
  /** Handles notices to be shown inside delivery box if applicable, eg: 'Leaves warehouse in 1-2 business days' */
  message: Scalars['String'];
  type: CartParcelDispatchNoticeType;
};

export type CartParcelDispatchNoticeType = 
  | 'SPECIAL_ORDER'
  | 'IN_STOCK'
  | 'BULKY_SPECIAL_ORDER'
  | 'BULKY_IN_STOCK';

/** This represents a line item in the cart */
export type CartParcelItem = {
  __typename?: 'CartParcelItem';
  /** ID of the cart group item */
  id: Scalars['ID'];
  /** Offer associated with the item */
  offer: Offer;
  /** Link to the line item, eg: '/product/5965847?ofid=372618927' */
  uri: Scalars['String'];
  /** Selected quantity of the item */
  quantity: Scalars['Int'];
  /** This item has free shipping (not including Club free shipping - see offer.clubFreeShipping) */
  freeShipping: Scalars['Boolean'];
  /** This item is eligible for club catch auto express shipping upgrade */
  clubAutoExpressShipping: Scalars['Boolean'];
  /** Total diplayed price for the item, inclusive of all quantities and tax */
  totalPrice: Money;
  /** Whether the item was added by a coupon for free, for example free merchandise */
  addedByCoupon: Scalars['Boolean'];
  /** The title to be displayed on the line item */
  title: Scalars['String'];
  /** Personalised values of item */
  personalisedValues: Array<PersonalisedValue>;
  /** Metadata about the line item (eg: tracking */
  metadata: CartParcelItemMetadata;
  /** Informative messages or errors for the customer at the item level */
  notices: Array<CartNotice>;
};

/**
 * Source metadata fields for Snowplow tracking representing the origin of the item in the cart.
 * These get stored on the cartItem to denote if the product came from Wishlist or Search or Product grid etc and the
 * position on the grid and platform etc where it originated.
 */
export type CartParcelItemMetadata = {
  __typename?: 'CartParcelItemMetadata';
  /** The ID of a tracking source, could be an int or a string in the case of search terms */
  sourceId?: Maybe<Scalars['String']>;
  /** The position the item is in a product grid */
  sourcePosition?: Maybe<Scalars['Int']>;
  /** The type of source tracking. See CartItem in CotdWebsite for full list of type ids */
  sourceType?: Maybe<Scalars['Int']>;
  /** The platform id (an int) 1 = Web, 2 = Mobile Web etc. See CotdWebsite Platform entity */
  sourcePlatform?: Maybe<SourcePlatformType>;
  /** The ID of event this product is part of, when added to cart */
  eventId?: Maybe<Scalars['Int']>;
};

export type CartParcelShippingOption = {
  __typename?: 'CartParcelShippingOption';
  /** ID of the shipping option */
  id: Scalars['ID'];
  /** The type of the shipping option, eg: click & collect, normal */
  type: DeliveryType;
  /** The type of place where the item is being delivered to, e.g. parcel locker, click and collect */
  locationType: DeliveryLocationType;
  /** Title of the shipping option, eg: 'Standard', 'Express', 'Pick Up' */
  title: Scalars['String'];
  /**
   * Before price to be displayed as-is with strikethrough if applicable, eg: '$5.99'
   * @deprecated We're removing strike through pricing to make things simpler for our customers
   */
  retailPrice?: Maybe<Money>;
  /** Price total to be displayed as-is, eg: '$4.50', 'FREE' */
  price: Money;
  /** If this shipping option is free with Club Catch */
  clubFreeShipping: Scalars['Boolean'];
  /**
   * The amount to add to standard shipping to get the express price
   * @deprecated Only for use by legacy iOS cart
   */
  expressDifferencePrice?: Maybe<Money>;
  /** A small tag to be shown if applicable, eg: 'CHEAPEST' */
  attentionTag?: Maybe<Scalars['String']>;
};

export type CartShippingLocation = {
  __typename?: 'CartShippingLocation';
  /** Name of the city, eg: 'Bentleigh East' */
  city?: Maybe<Scalars['String']>;
  /** Postcode, eg: '3000' */
  postcode: Scalars['String'];
};

export type CartUpsellRecommendationInput = {
  productIds: Array<Scalars['ID']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
};

export type CartUpsellResponse = {
  __typename?: 'CartUpsellResponse';
  /** Full product data to return */
  product?: Maybe<Product>;
  metaData: RecommenderMetaData;
};

/**
 * A customer category, which defines the grouping of items on the website, externally this is mapped to the seller categories and buyer categories.
 * 
 * `owner(tribe: "Digital", squad: "search-and-discover")`
 */
export type Category = {
  __typename?: 'Category';
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  id: Scalars['ID'];
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  name: Scalars['String'];
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  slug: Scalars['String'];
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  level: Scalars['Int'];
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  parent?: Maybe<Category>;
  /**
   * Whether or not this is the final category in the hierarchy.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  leaf: Scalars['Boolean'];
};

export type CategoryByIdInput = {
  id: Scalars['ID'];
};

export type CategoryRecommendProductsInput = {
  /** same as shop slug */
  category: Scalars['String'];
  userId: Scalars['String'];
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
};

export type CategoryRecommendedProductsResponse = {
  __typename?: 'CategoryRecommendedProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
};

/** Checkout information */
export type Checkout = {
  __typename?: 'Checkout';
  /** Identifier to assist data normalisation within Apollo cache */
  id: Scalars['ID'];
  /** Informative messages or errors for the customer at the cart level (displayed at top) */
  notices: Array<CheckoutNotice>;
  /** The customer checking out */
  customer?: Maybe<Customer>;
  /** The cart being checked out */
  cart: Cart;
  /** A list of available payment methods */
  paymentMethods: Array<PaymentMethod>;
  /** The selected payment method */
  selectedPaymentMethod?: Maybe<PaymentMethod>;
  /** Flags whether the cart is on a sales channel that supports gift card payments */
  giftCardSupported: Scalars['Boolean'];
  /** The ID of the chosen delivery address. Defaults to the default address. */
  selectedAddress?: Maybe<Address>;
  /** Determines single-item, buy-now express checkout flow */
  express?: Maybe<Scalars['Boolean']>;
};

export type CheckoutMutationResponse = Checkout | UserError;

/** A notice to display at the checkout */
export type CheckoutNotice = {
  __typename?: 'CheckoutNotice';
  /** Text details of the checkout notice */
  message: TemplateString;
  /** Type of the notice, eg: 'ERROR', 'INFO' */
  type: CheckoutNoticeType;
  /** If the notice is advisory, checkout can still occur (meaning the notice is non blocking) */
  advisory: Scalars['Boolean'];
};

/** CheckoutNoticeType is used to determine the colour to display on the frontend and whether the notice blocks checkout */
export type CheckoutNoticeType = 
  | 'ERROR'
  | 'WARNING'
  | 'INFO';

/**
 * Information about customer's ClubCatch membership
 * 
 * `owner(tribe: "Digital", squad: "loyalty")`
 */
export type ClubCustomerSubscription = ClubSubscription & {
  __typename?: 'ClubCustomerSubscription';
  /**
   * Whether current subscription is active
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  active: Scalars['Boolean'];
  /**
   * Whether user has been a Club Catch or Catch-OnePass member before
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  hasBeenClubCatchMember: Scalars['Boolean'];
  /**
   * Whether current subscription is under free trial period
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   * @deprecated use onFreeTrial
   */
  freeTrial: Scalars['Boolean'];
  /**
   * Whether current subscription is under free trial period
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  onFreeTrial: Scalars['Boolean'];
  /**
   * Number of active days remaining until current active period ends
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  activeDaysRemaining: Scalars['Int'];
  /**
   * Whether current subscription is auto renewing. False means it is cancelling.
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  autoRenewing: Scalars['Boolean'];
  /**
   * Current subscription interval
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  interval: ClubSubscriptionInterval;
  /**
   * The purchase price of current subscription
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  purchasePrice?: Maybe<Scalars['String']>;
  /**
   * The start date of the current subscription
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  latestMembershipPeriodStart?: Maybe<Scalars['DateTime']>;
  /**
   * The end date of the current subscription. a.k.a. expiry date or next billing date
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  latestMembershipPeriodEnd?: Maybe<Scalars['DateTime']>;
  /**
   * Whether the user is eligible for free trial
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  freeTrialEligible: Scalars['Boolean'];
  /**
   * Number of days remaining of free trial of current subscription
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  freeTrialDaysRemaining?: Maybe<Scalars['Int']>;
  /**
   * owner(tribe: "Digital", squad: "loyalty")
   * @deprecated use latestMembershipPeriodEnd
   */
  nextBillingDate: Scalars['DateTime'];
};

export type ClubSubscription = {
  /** Subscription interval */
  interval: ClubSubscriptionInterval;
  /** Subscription next billing date aka expiry date */
  nextBillingDate: Scalars['DateTime'];
};

export type ClubSubscriptionInterval = 
  | 'MONTHLY'
  | 'YEARLY';

export type CoPurchasedProducts = {
  __typename?: 'CoPurchasedProducts';
  products: Array<Product>;
  metaData: RecommenderMetaData;
};

export type CoPurchasedProductsInput = {
  productId: Scalars['ID'];
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  excludedProductIds?: Maybe<Array<Scalars['ID']>>;
  includeClubProducts?: Maybe<Scalars['Boolean']>;
};

/** Namespace for configuration queries */
export type Configuration = {
  __typename?: 'Configuration';
  header: HeaderConfiguration;
};


/** Namespace for configuration queries */
export type ConfigurationHeaderArgs = {
  input?: Maybe<HeaderConfigurationInput>;
};

/**
 * Single coupon data
 * 
 * All fields except id, code, toDate, salesRule.shortDescription, longDescription are used for tracking purpose
 * 
 *     `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type Coupon = {
  __typename?: 'Coupon';
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  id: Scalars['ID'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  code: Scalars['String'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  fromDate: Scalars['DateTime'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  toDate: Scalars['DateTime'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  usageLimit?: Maybe<Scalars['Int']>;
  /**
   * The number of times the coupon can be used by any given customer
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  usagePerCustomer?: Maybe<Scalars['Int']>;
  /**
   * Is coupon assigned to a specific list of customers
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  specificCustomers: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  isActive: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  promoActive: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  version: Scalars['Float'];
  /**
   * used to sort coupon in the backend
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  ordinal: Scalars['Int'];
  /**
   * The number of times the coupon has been used
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  timesUsed: Scalars['Int'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  salesRule: SalesRule;
};

export type CouponByCodeInput = {
  code: Scalars['String'];
};

export type CouponPayload = Coupon | UserError;

export type CouponsPayload = CustomerCoupons | UserError;


/**
 * Represents information about a Catch customer
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type Customer = User & Node & {
  __typename?: 'Customer';
  /**
   * Customer UUID
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  id: Scalars['ID'];
  /**
   * First name of customer
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  firstName?: Maybe<Scalars['String']>;
  /**
   * Last name of customer
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  lastName?: Maybe<Scalars['String']>;
  /**
   * Email address of customer
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  email: Scalars['EmailAddress'];
  /**
   * Display name of customer
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  displayName?: Maybe<Scalars['String']>;
  /**
   * Address information of customer
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  addressBook?: Maybe<AddressBook>;
  /**
   * Membership details of customer
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  membership?: Maybe<Membership>;
  /**
   * Information about customer's club Catch membership
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  club?: Maybe<ClubCustomerSubscription>;
};


/**
 * Represents information about a Catch customer
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type CustomerMembershipArgs = {
  input?: Maybe<MembershipInput>;
};

/**
 * All coupons related to a customer
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type CustomerCoupons = {
  __typename?: 'CustomerCoupons';
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  coupons: Array<Coupon>;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  customerId: Scalars['ID'];
};



/** Delete customer input */
export type DeleteCustomerInput = {
  /** Reason for deleting customer */
  reason?: Maybe<Scalars['String']>;
};

export type DeleteCustomerResponse = BooleanResponse | UnauthorisedUserError | UserError;

export type DeliveryLocationType = 
  | 'NORMAL'
  | 'PARCEL_LOCKER'
  | 'CLICK_AND_COLLECT';

export type DeliveryType = 
  | 'STANDARD'
  | 'EXPRESS'
  | 'PICKUP';


/** Interface that can be implemented for user facing error types */
export type Error = {
  message: Scalars['String'];
};

export type EssentialsMenu = {
  __typename?: 'EssentialsMenu';
  giftCards?: Maybe<Scalars['String']>;
  catchMobile: Scalars['String'];
};

/**
 * Events are a type of customer facing entity that can be scheduled and typically have a collection of Products associated with them.
 * Events also contain information such as title, subtitle, as well other generic high level data use to describe itself.
 * 
 *     `owner(tribe: "Digital", squad: "search-and-discover")`
 */
export type Event = {
  __typename?: 'Event';
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  id: Scalars['ID'];
  /**
   * The title of the Event.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  title: Scalars['String'];
  /**
   * The URL pointing to the Event view.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  url: Scalars['String'];
  /**
   * Event banner image in different sizes.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  image: EventImage;
  /**
   * The badge text of the Event, which contains additional information pertaining to the Event.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  badgeText?: Maybe<Scalars['String']>;
  /**
   * The product count of the Event.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  productCount: Scalars['Int'];
  /**
   * This field is to be populated when an Event only has one product associated with it.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  product?: Maybe<Product>;
};

export type EventBySlugInput = {
  slug: Scalars['String'];
};

export type EventBySlugResponse = {
  __typename?: 'EventBySlugResponse';
  event?: Maybe<Event>;
};

export type EventImage = {
  __typename?: 'EventImage';
  single: Image;
  wide?: Maybe<Image>;
};

export type ExistingCustomer = {
  __typename?: 'ExistingCustomer';
  exists: Scalars['Boolean'];
};

export type ExistingCustomerInput = {
  email: Scalars['EmailAddress'];
};

export type ExistingCustomerResponse = ExistingCustomer | UserError;

export type Experiment = {
  __typename?: 'Experiment';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['ID']>;
  experiment: Scalars['String'];
  bucket: Scalars['Int'];
  variation: Scalars['String'];
  active: Scalars['Boolean'];
};

export type ExperimentsInput = {
  experiments: Array<Scalars['String']>;
};

export type ExperimentsPayload = {
  __typename?: 'ExperimentsPayload';
  experiments: Array<Experiment>;
  ccx?: Maybe<Scalars['String']>;
};

/** Data to display the footer on Catch.com.au */
export type Footer = {
  __typename?: 'Footer';
  /** Page links displayed in the footer */
  navigationLinkColumns: Array<NavigationLinkColumn>;
  /** Copyright and disclaimer information for the footer (HTML) */
  copyright: Scalars['String'];
  /** App download links */
  appDownloadLinks: Array<AppDownloadLink>;
};

export type FrequentlyBoughtTogetherInput = {
  productIds: Array<Scalars['ID']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
};

export type FrequentlyBoughtTogetherResponse = {
  __typename?: 'FrequentlyBoughtTogetherResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
};

/** Configuration used to connect to GTM */
export type GtmConfiguration = AnalyticVendorConfiguration & {
  __typename?: 'GTMConfiguration';
  enabled: Scalars['Boolean'];
  containerId: Scalars['String'];
};

/**
 * Schema for geolocation data i.e. latitude and longitude
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type Geolocation = {
  __typename?: 'Geolocation';
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  latitude?: Maybe<Scalars['Float']>;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  longitude?: Maybe<Scalars['Float']>;
};

/** Configuration used to render the Catch.com.au header */
export type HeaderConfiguration = {
  __typename?: 'HeaderConfiguration';
  meta: HeaderMetaConfiguration;
  topHeader: TopHeaderConfiguration;
  primaryHeader: PrimaryHeaderConfiguration;
  headerTheme?: Maybe<HeaderTheme>;
  megaMenu: MegaMenuConfiguration;
};

/** Optional input for header configuration */
export type HeaderConfigurationInput = {
  domain: Scalars['String'];
};

/** Header Meta Data */
export type HeaderMetaConfiguration = {
  __typename?: 'HeaderMetaConfiguration';
  salesChannel: HeaderMetaSalesChannelConfiguration;
};

/** Header sales channel configuration */
export type HeaderMetaSalesChannelConfiguration = {
  __typename?: 'HeaderMetaSalesChannelConfiguration';
  code: Scalars['String'];
};

export type HeaderTheme = 
  | 'christmas';

/** An image type MediaAsset */
export type Image = MediaAsset & {
  __typename?: 'Image';
  id: Scalars['ID'];
  /** The id can be 'placeholder' when no image is found and the placeholder is returned */
  url: Scalars['URL'];
  altText: Scalars['String'];
  /** The height of the image in pixels */
  height: Scalars['Int'];
  /** The width of the image in pixels */
  width: Scalars['Int'];
};



export type KasadaConfiguration = {
  __typename?: 'KasadaConfiguration';
  scriptUrl?: Maybe<Scalars['String']>;
  protectedEndpoints: Array<Maybe<KasadaProtectedEndpoints>>;
};

export type KasadaConfigurationInput = {
  domain: Scalars['String'];
};

export type KasadaProtectedEndpoints = {
  __typename?: 'KasadaProtectedEndpoints';
  method: Scalars['String'];
  path: Scalars['String'];
  domain: Scalars['String'];
};

/**
 * A summary of the customer's order. This does not include any gift card use and donation round up
 * Only use in iOS.
 */
export type LegacyCartOrderSummary = {
  __typename?: 'LegacyCartOrderSummary';
  discounts: Array<LegacyOrderSummaryDiscount>;
  /** Shipping cost */
  shippingPrice?: Maybe<Money>;
  /** Store credit applied */
  storeCreditApplied?: Maybe<Money>;
  /** Subtotal derived from all items in each cart group */
  subtotalPrice: Money;
  /** Final total cost to the customer, exclude gift card and donation round up */
  totalPrice: Money;
};

export type LegacyOrderSummaryDiscount = {
  __typename?: 'LegacyOrderSummaryDiscount';
  discount: Money;
  name: Scalars['String'];
};

/**
 * Location data
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type Location = {
  __typename?: 'Location';
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  id: Scalars['Int'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  postcode: Scalars['String'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  suburb: Scalars['String'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  state?: Maybe<Scalars['String']>;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  country?: Maybe<Scalars['String']>;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  geolocation?: Maybe<Geolocation>;
};

/**
 * Input for postcode suggestions query
 * 
 * If no input is provided, all postcodes in the current user's country will be returned
 * 
 *     `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type LocationSuggestionsInput = {
  postcode?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  searchParameters?: Maybe<LocationSuggestionsSearchParameters>;
};

/** owner(tribe: "Digital", squad: "shopping-experience") */
export type LocationSuggestionsResult = {
  __typename?: 'LocationSuggestionsResult';
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  postcodes: Array<Location>;
};

/**
 * Search parameters for postcode suggestions
 * 
 * searchTerm can be either a postcode or a suburb name
 * filterByGeolocation filters out postcodes that do not have any geolocation data
 * 
 *     `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type LocationSuggestionsSearchParameters = {
  searchTerm?: Maybe<Scalars['String']>;
  maxResults?: Maybe<Scalars['Int']>;
  filterByGeolocation?: Maybe<Scalars['Boolean']>;
};

/** A reference to a media asset via a URL (images, videos, etc.) */
export type MediaAsset = {
  id: Scalars['ID'];
  /** The address of the asset */
  url: Scalars['URL'];
  /** The alt text of the asset */
  altText: Scalars['String'];
};

/** Mega menu configuration */
export type MegaMenuConfiguration = {
  __typename?: 'MegaMenuConfiguration';
  enabled: Scalars['Boolean'];
  navData: MegaMenuData;
};

export type MegaMenuData = {
  __typename?: 'MegaMenuData';
  shops: Array<Shop>;
  catchEssentialsMenu?: Maybe<EssentialsMenu>;
  accountMenu: AccountMenu;
};

/**
 * Membership details of a customer
 * 
 * `owner(tribe: "CAL", squad: "LS")`
 */
export type Membership = {
  __typename?: 'Membership';
  /** owner(tribe: "CAL", squad: "LS") */
  id?: Maybe<Scalars['ID']>;
  /**
   * owner(tribe: "CAL", squad: "LS")
   * @deprecated use membership.linked
   */
  onePassLinked: Scalars['Boolean'];
  /**
   * owner(tribe: "CAL", squad: "LS")
   * @deprecated use membership.subscription.active
   */
  hasActiveOnePassSubscription: Scalars['Boolean'];
  /**
   * owner(tribe: "CAL", squad: "LS")
   * @deprecated use membership.subscription.freeTrialEligible
   */
  eligibleFreeTrial: Scalars['Boolean'];
  /**
   * owner(tribe: "CAL", squad: "LS")
   * @deprecated use membership.subscription.onFreeTrial
   */
  isFreeTrial: Scalars['Boolean'];
  /**
   * owner(tribe: "CAL", squad: "LS")
   * @deprecated use membership.subscription.freeTrialDaysRemaining
   */
  freeTrialDaysRemaining?: Maybe<Scalars['Int']>;
  /** owner(tribe: "CAL", squad: "LS") */
  linked: Scalars['Boolean'];
  /** owner(tribe: "CAL", squad: "LS") */
  eligibleForUpsell: Scalars['Boolean'];
  /** owner(tribe: "CAL", squad: "LS") */
  eligibleForMigration: Scalars['Boolean'];
  /** owner(tribe: "CAL", squad: "LS") */
  doubleSubscription: Scalars['Boolean'];
  /** owner(tribe: "CAL", squad: "LS") */
  subscription?: Maybe<MembershipSubscriptionDetails>;
  /** owner(tribe: "CAL", squad: "LS") */
  benefits?: Maybe<MembershipBenefits>;
};

/** Membership benefits */
export type MembershipBenefits = {
  __typename?: 'MembershipBenefits';
  freeDelivery: Scalars['Boolean'];
  exclusiveOffers: Scalars['Boolean'];
  memberDiscounts: Scalars['Boolean'];
  extraPoints: Scalars['Boolean'];
};

export type MembershipInput = {
  /** Flag to force refresh customer's membership data */
  refresh?: Maybe<Scalars['Boolean']>;
};

/** Membership Subscription details */
export type MembershipSubscriptionDetails = {
  __typename?: 'MembershipSubscriptionDetails';
  active: Scalars['Boolean'];
  onFreeTrial: Scalars['Boolean'];
  activeDaysRemaining: Scalars['Int'];
  autoRenewing: Scalars['Boolean'];
  interval?: Maybe<Scalars['String']>;
  latestMembershipPeriodStart?: Maybe<Scalars['DateTime']>;
  latestMembershipPeriodEnd?: Maybe<Scalars['DateTime']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  renewalPrice?: Maybe<Scalars['Int']>;
  monthlyPrice: Scalars['Int'];
  yearlyPrice: Scalars['Int'];
  freeTrialDaysRemaining?: Maybe<Scalars['Int']>;
  freeTrialEligible: Scalars['Boolean'];
};

/** Represent a meta URL format */
export type MetaUrl = {
  __typename?: 'MetaURL';
  url: Scalars['URL'];
  media?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

/** Meta URL for a page */
export type MetaUrLs = {
  __typename?: 'MetaURLs';
  canonical: MetaUrl;
  alternate: Array<MetaUrl>;
};

export type ModelType = 
  | 'DESCRIPTION'
  | 'IMAGE'
  | 'IMAGE_AND_DESCRIPTION';

/** Money object to handle currency */
export type Money = {
  __typename?: 'Money';
  /** monetary value in lowest divisible unit for currency (eg. cents for AUD) */
  amount: Scalars['Int'];
  /** currency value such as AUD */
  currency: Scalars['Currency'];
};

/** Move item to wishlist */
export type MoveItemFromCartToWishlistInput = {
  id: Scalars['ID'];
};

/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type Mutation = {
  __typename?: 'Mutation';
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  placeholder?: Maybe<Scalars['String']>;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  addItemsToCart: CartBatchMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  addToCart: CartMutationResponse;
  /**
   * Add or remove a donation on the users cart
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  toggleDonation: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  moveItemFromCartToWishlist: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  redeemGiftCard: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  removeCart: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  removeCouponFromCart: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  removeGiftCardFromCart: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  removeItemFromCart: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  updateCartItemQuantity: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  updateCartLocation: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  updateCartProductOption: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  updateCartShippingOption: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  updateCartCoupon: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  selectAddress: CheckoutMutationResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  addAddress: AddAddressResponse;
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  deleteCustomer: DeleteCustomerResponse;
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  addItemToWishlist: WishlistItemMutationResponse;
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  removeItemFromWishlist: RemoveItemFromWishlistMutationResponse;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationAddItemsToCartArgs = {
  input: AddItemsToCartInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationAddToCartArgs = {
  input: AddToCartInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationToggleDonationArgs = {
  input: ToggleDonationInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationMoveItemFromCartToWishlistArgs = {
  input: MoveItemFromCartToWishlistInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationRedeemGiftCardArgs = {
  input: RedeemGiftCardInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationRemoveGiftCardFromCartArgs = {
  input: RemoveGiftCardFromCartInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationRemoveItemFromCartArgs = {
  input: RemoveItemFromCartInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationUpdateCartItemQuantityArgs = {
  input: UpdateCartItemQuantityInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationUpdateCartLocationArgs = {
  input: UpdateCartLocationInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationUpdateCartProductOptionArgs = {
  input: UpdateCartProductOptionInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationUpdateCartShippingOptionArgs = {
  input: UpdateCartShippingOptionInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationUpdateCartCouponArgs = {
  input: UpdateCartCouponInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationSelectAddressArgs = {
  input: SelectAddressInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationAddAddressArgs = {
  input: AddAddressInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationAddItemToWishlistArgs = {
  input: AddItemToWishlistInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type MutationRemoveItemFromWishlistArgs = {
  input: RemoveItemFromWishlistInput;
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  id: Scalars['Int'];
  slug: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

/** A link within the footers column display */
export type NavigationLink = {
  __typename?: 'NavigationLink';
  /** The text content of the link (eg: Privacy Policy) */
  text: Scalars['String'];
  /** URL of the link */
  url: Scalars['String'];
  /** If true, link should spawn in a new window as opposed to the current window */
  openInNewWindow: Scalars['Boolean'];
};

/** A column of links in the footer */
export type NavigationLinkColumn = {
  __typename?: 'NavigationLinkColumn';
  /** Title text of the column (eg: Legal) */
  columnTitle: Scalars['String'];
  /** List of links within the column */
  links: Array<NavigationLink>;
};

/** An object with an ID to support global identification. */
export type Node = {
  /** Globally unique identifier. */
  id: Scalars['ID'];
};

/**
 * An offer to sell a variant of a product, the person making the offer may be catch or a marketplace seller. Each variant can have multiple offers, each of which will contain a condition, quantity and price they are offering to sell the product for. The price of an offer will alter and change depending on the promotions applied.
 * 
 * `owner(tribe: "Digital", squad: "search-and-discover")`
 */
export type Offer = {
  __typename?: 'Offer';
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  id: Scalars['ID'];
  /**
   * Which sales channel the offer is for, should match the header value.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  salesChannel: SalesChannel;
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  seller: Seller;
  /**
   * The price this seller is currently offering to sell the variant for.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  sellPrice: Money;
  /**
   * Information on how the price tag should be displayed
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  priceTag?: Maybe<PriceTag>;
  /**
   * The price this seller was originally offering to sell the variant for, prior to application of any promotions.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  originPrice?: Maybe<Money>;
  /**
   * The RRP price for this variant.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  retailPrice?: Maybe<Money>;
  /**
   * The current price that the seller is offering to sell to club member for.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  clubSellPrice?: Maybe<Money>;
  /**
   * Any disclaimer information regarding the retail price used.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   * @deprecated use `priceTag.retailPriceDisclaimer`
   */
  retailPriceDisclaimer?: Maybe<ProductRetailPriceDisclaimer>;
  /**
   * This field will return a indicative (to a fairly high level of reliability) state of stock.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  stockLevel: StockLevel;
  /**
   * The maximum quantity that can be added to cart for this offer.
   * It is calculated by the lowest value of the purchase limit and an estimated available stock amount (restricted to a realistic upper bound).
   * Typically used to set an upper bound on a quantity selector, given the very high latency on inventory updates, this value is not reliable on trending items.
   * 
   *     `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  purchasableQuantity: Scalars['Int'];
  /**
   * The maximum amount of items a person can purchase for the offer at one time (per sale).
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  purchaseLimit?: Maybe<Scalars['Int']>;
  /**
   * Whether this item is available for click and collect
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  clickAndCollect: Scalars['Boolean'];
  /**
   * Whether the offer is eligible for free shipping for club members.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  clubFreeShipping: Scalars['Boolean'];
  /**
   * Whether this item can only be bought by Club members.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  clubExclusive: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  variant: Variant;
  /**
   * The currency code for an offer.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  currency: Scalars['Currency'];
  /**
   * Whether this offer has free shipping.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  freeShipping: Scalars['Boolean'];
  /**
   * The best before date for an offer.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  bestBefore?: Maybe<Scalars['DateTime']>;
  /**
   * The expiry date for an offer.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /**
   * The redeem by date for an offer.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  redeemBy?: Maybe<Scalars['DateTime']>;
  /**
   * The promotion end date for an offer
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  promotionEndDate?: Maybe<Scalars['DateTime']>;
  /**
   * Whether the offer is a catch promotion
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  catchPromotion: Scalars['Boolean'];
  /**
   * Warranty information
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  warranty?: Maybe<ProductWarranty>;
};

export type OrderSummaryDelivery = {
  __typename?: 'OrderSummaryDelivery';
  total: Money;
  deliveryType: DeliveryType;
};

export type OrderSummaryDiscount = {
  __typename?: 'OrderSummaryDiscount';
  discount: Money;
  label: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  deletable: Scalars['Boolean'];
  type: OrderSummaryDiscountType;
};

export type OrderSummaryDiscountType = 
  | 'MANUAL'
  | 'AUTOMATIC'
  | 'CLUB_FREE_SHIPPING';

export type OrderSummaryDonation = {
  __typename?: 'OrderSummaryDonation';
  /** The amount of donation */
  total: Money;
  organisationName: Scalars['String'];
  image: Image;
  body: Scalars['String'];
  header: Scalars['String'];
  /** The order price before the donation */
  orderTotalBefore: Money;
  /** The order price after the donation */
  orderTotalAfter: Money;
  /** Customer agreed to donate or not */
  selected: Scalars['Boolean'];
};

export type OrderSummaryGiftCard = {
  __typename?: 'OrderSummaryGiftCard';
  code: Scalars['String'];
  appliedBalance: Money;
  remainingBalance: Money;
};

export type OrderSummaryItems = {
  __typename?: 'OrderSummaryItems';
  total: Money;
  items: Array<CartParcelItem>;
};

/** Information about a cursor pagination result set */
export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  /** Type of payment method */
  type: PaymentType;
  /** Description of the payment method to display */
  description: Scalars['String'];
  /** Image URL */
  imageSrc?: Maybe<Scalars['String']>;
};

export type PaymentType = 
  | 'CREDIT_CARD'
  | 'PAYPAL'
  | 'ZIPPAY'
  | 'AFTERPAY'
  | 'LATITUDEPAY'
  | 'GENOAPAY';

export type PeopleAlsoViewedInput = {
  productIds: Array<Scalars['ID']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
};

export type PeopleAlsoViewedResponse = {
  __typename?: 'PeopleAlsoViewedResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
};

export type PersonalisedRecommendedProductsInput = {
  sellerId?: Maybe<Scalars['Int']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyOnePassEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
};

export type PersonalisedRecommendedProductsResponse = {
  __typename?: 'PersonalisedRecommendedProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
};

/** The customised key-value pair for a personalised product */
export type PersonalisedValue = {
  __typename?: 'PersonalisedValue';
  /** The field name to display in the frontend eg: 'Receiver's FirstName' */
  label: Scalars['String'];
  /** The customised value provided by the customer eg: 'Joe' */
  value: Scalars['String'];
};

/** Values for a personalised product */
export type PersonalisedValueInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Platform = 
  | 'DESKTOP'
  | 'MOBILE'
  | 'IPAD'
  | 'IPHONE'
  | 'ANDROID';


export type PriceDiscount = {
  __typename?: 'PriceDiscount';
  /** Discount text to be displayed above the price tag. eg. 'Price Drop'. */
  label: Scalars['String'];
  /** Percentage discount displayed with discount text. eg. '35% Off'. */
  percentageLabel?: Maybe<Scalars['String']>;
  /** The end date for a price discount. Can be used for countdown timer. */
  endDate?: Maybe<Scalars['DateTime']>;
};

export type PriceLabel = {
  __typename?: 'PriceLabel';
  /** The was price displayed on the left of the price tag. */
  wasPrice?: Maybe<Money>;
  /** The selling price displayed in the middle of the price tag. */
  price: Money;
  /** Information to display the saving on the right of the price tag */
  saving?: Maybe<PriceLabelSaving>;
};

export type PriceLabelSaving = {
  __typename?: 'PriceLabelSaving';
  /** The savings label. eg. 'Save'. */
  label: Scalars['String'];
  /** The savings price. */
  savingAmount: Money;
};

/** owner(tribe: "Digital", squad: "search-and-discovery") */
export type PriceTag = {
  __typename?: 'PriceTag';
  /**
   * Information to display the discount above tag.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discovery")`
   */
  priceDiscount?: Maybe<PriceDiscount>;
  /**
   * Text to appear above the price tag. eg 'From' or 'Don't pay $9.99'.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discovery")`
   */
  topLabel?: Maybe<Scalars['String']>;
  /**
   * Information to display the main price label.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discovery")`
   */
  priceLabel: PriceLabel;
  /**
   * The club exlusive price. Will be displayed below price tag.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discovery")`
   */
  clubSellPrice?: Maybe<Money>;
  /**
   * Flag that will determine if this is a club price tag.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discovery")`
   */
  clubExclusive: Scalars['Boolean'];
  /**
   * Flag that will determine if the tag is enabled or greyed out.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discovery")`
   */
  enabled: Scalars['Boolean'];
  /**
   * Any disclaimer information regarding the retail price used.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discovery")`
   */
  retailPriceDisclaimer?: Maybe<ProductRetailPriceDisclaimer>;
};

/** Primary header account configuration */
export type PrimaryHeaderAccountFlag = {
  __typename?: 'PrimaryHeaderAccountFlag';
  enabled: Scalars['Boolean'];
  showFlybuysLink: Scalars['Boolean'];
};

/**
 * Primary header club configuration
 * 
 * `owner(tribe: "CAL", squad: "LS")`
 */
export type PrimaryHeaderClubFlag = {
  __typename?: 'PrimaryHeaderClubFlag';
  /** owner(tribe: "CAL", squad: "LS") */
  enabled: Scalars['Boolean'];
  /** owner(tribe: "CAL", squad: "LS") */
  clubCatchTileEnabled: Scalars['Boolean'];
};

/** Configuration for the main section of the header */
export type PrimaryHeaderConfiguration = {
  __typename?: 'PrimaryHeaderConfiguration';
  logo: PrimaryHeaderLogoFlag;
  searchBar: PrimaryHeaderFlag;
  club: PrimaryHeaderClubFlag;
  clubFlybuys: PrimaryHeaderFlag;
  flybuys: PrimaryHeaderFlag;
  cart: PrimaryHeaderFlag;
  wishlist: PrimaryHeaderFlag;
  myAccount: PrimaryHeaderAccountFlag;
  userLocation: PrimaryHeaderFlag;
};

/** Primary header flat configuration */
export type PrimaryHeaderFlag = {
  __typename?: 'PrimaryHeaderFlag';
  enabled: Scalars['Boolean'];
};

/** Logo Configuration */
export type PrimaryHeaderLogoFlag = {
  __typename?: 'PrimaryHeaderLogoFlag';
  enabled: Scalars['Boolean'];
  imageSrc: Scalars['String'];
  condensedImageSrc?: Maybe<Scalars['String']>;
  alt: Scalars['String'];
  url: Scalars['String'];
};

/**
 * A customer-facing item or service that can be sold. Products contain information such as title, description, as well other generic high level data use to describe itself.
 * 
 * `owner(tribe: "Digital", squad: "search-and-discover")`
 */
export type Product = {
  __typename?: 'Product';
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  id: Scalars['ID'];
  /**
   * A URL safe, human readable unique identifier for the product.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  slug: Scalars['String'];
  /**
   * The title of the product.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  title: Scalars['String'];
  /**
   * The products html description to be shown on the web.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  description?: Maybe<Scalars['String']>;
  /**
   * Any details about the products specifications in html.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  specifications?: Maybe<Scalars['String']>;
  /**
   * Comma separated list of keywords associated with the product.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  keywords?: Maybe<Scalars['String']>;
  /**
   * Product html information to be displayed with in the footer.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  footer?: Maybe<Scalars['String']>;
  /**
   * Is the product sellable, which means does it have offers with stock.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  sellable: Scalars['Boolean'];
  /**
   * Whether the product should be visible on the website.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  visible: Scalars['Boolean'];
  /**
   * Whether the product should display a from price tag (e.g. from $6.95).
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  fromPriceLabel: Scalars['Boolean'];
  /**
   * Information on how the price tag should be displayed
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  priceTag?: Maybe<PriceTag>;
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  bestOffer?: Maybe<Offer>;
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  brand?: Maybe<Brand>;
  /**
   * This is the customer category.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  category?: Maybe<Category>;
  /**
   * The customer collection of all the values for each option, which holds high level data about the product range,
   * including all of the options and all their possible values.
   * This data is used just for display and not mappable or representational of actual variants for sale.
   * 
   *     `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  options: Array<ProductOption>;
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  variants: Array<Variant>;
  /**
   * The products assets (images, videos, etc.)
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  assets: ProductAssets;
  /**
   * The ratings summary (average rating, the count of ratings)
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  ratingsSummary: RatingsSummary;
  /**
   * Determines whether product is considered sensitive and hidden from product feeds
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  sensitive: Scalars['Boolean'];
  /**
   * Determines if customer must be 18 years or over to purchase product (e.g. knives, alcohol, dangerous goods, etc.)
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  ageRestricted: Scalars['Boolean'];
  /**
   * Determines if customer must be 18 years or over in order to both view and purchase product
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  adult: Scalars['Boolean'];
  /**
   * Meta URLs for a product, usually for SEO purpose
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  metaURLs?: Maybe<MetaUrLs>;
};

/**
 * Product Assets. Containing a hero, gallery and size charts.
 * 
 * `owner(tribe: "Digital", squad: "search-and-discover")`
 */
export type ProductAssets = {
  __typename?: 'ProductAssets';
  /**
   * The primary asset of Product. The asset users see when viewing products in a list.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  hero: Image;
  /**
   * The gallery assets are visible on the Product page
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  gallery: Array<MediaAsset>;
  /**
   * Size chart assets which are used as size guides for customers
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  sizeCharts: Array<Image>;
};

export type ProductByIdInput = {
  id: Scalars['ID'];
};

/** The options and all their possible values which make up this product. */
export type ProductOption = {
  __typename?: 'ProductOption';
  id: Scalars['ID'];
  name: Scalars['String'];
  values: Array<ProductOptionValue>;
};

/** The values of each of the options which are in-use by a variant. */
export type ProductOptionValue = {
  __typename?: 'ProductOptionValue';
  id: Scalars['ID'];
  /** The name of the value */
  name: Scalars['String'];
  /** The option associated with this option value */
  option: ProductOption;
};

/**
 * Product disclaimer information for retail price
 * 
 * `owner(tribe: "Digital", squad: "search-and-discover")`
 */
export type ProductRetailPriceDisclaimer = {
  __typename?: 'ProductRetailPriceDisclaimer';
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  description: Scalars['String'];
};

/**
 * Warranty information associated with each product
 * 
 * `owner(tribe: "Digital", squad: "search-and-discover")`
 */
export type ProductWarranty = {
  __typename?: 'ProductWarranty';
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  type: ProductWarrantyType;
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  description?: Maybe<Scalars['String']>;
};

/** Warranty information types */
export type ProductWarrantyType = 
  | 'CATCH'
  | 'MANUFACTURER'
  | 'DIRECT_IMPORT'
  | 'NONE';

/** Query root type */
export type Query = {
  __typename?: 'Query';
  placeholder?: Maybe<Scalars['String']>;
  bannerByPage?: Maybe<BannerByPageResponse>;
  cart: Cart;
  brandById?: Maybe<Brand>;
  categoryById?: Maybe<Category>;
  productById?: Maybe<Product>;
  checkout: Checkout;
  /** Namespace for CMS configuration */
  cmsConfiguration: CmsConfiguration;
  /** All information belonging to the footer box */
  footer: Footer;
  /** @deprecated Use cmsConfiguration query instead */
  configuration: Configuration;
  textBlock?: Maybe<TextBlock>;
  couponsFromUser: CouponsPayload;
  couponByCode: CouponPayload;
  /** Get Customer information. Return null if customer can't be identified */
  customer?: Maybe<Customer>;
  existingCustomer: ExistingCustomerResponse;
  /** Fetches a list of matching location objects based on searchTerm, postcode or suburb provided */
  locationSuggestions: LocationSuggestionsResult;
  eventBySlug: EventBySlugResponse;
  experiments: ExperimentsPayload;
  brandRecommendedProducts: BrandRecommendedProductsResponse;
  /** Recommend a product to the user based on what items they have in their cart */
  cartUpsellRecommendation: CartUpsellResponse;
  categoryRecommendedProducts: CategoryRecommendedProductsResponse;
  coPurchasedProducts: CoPurchasedProducts;
  frequentlyBoughtTogether: FrequentlyBoughtTogetherResponse;
  peopleAlsoViewed: PeopleAlsoViewedResponse;
  personalisedRecommendedProducts: PersonalisedRecommendedProductsResponse;
  recentlyViewed: RecentlyViewedResponse;
  recommendedEvents: RecommendedEventsResponse;
  recommendedEventsV2: RecommendedEventsV2Response;
  sellerRecommendedProducts: SellerRecommendedProductsResponse;
  similarProducts: SimilarProductsResponse;
  trendingProducts: TrendingProductsResponse;
  /** @deprecated Use securityConfiguration query instead */
  security: Security;
  /** All frontend public security related configuration */
  securityConfiguration: Security;
};


/** Query root type */
export type QueryBannerByPageArgs = {
  input: BannerByPageInput;
};


/** Query root type */
export type QueryBrandByIdArgs = {
  input: BrandByIdInput;
};


/** Query root type */
export type QueryCategoryByIdArgs = {
  input: CategoryByIdInput;
};


/** Query root type */
export type QueryProductByIdArgs = {
  input: ProductByIdInput;
};


/** Query root type */
export type QueryTextBlockArgs = {
  input: TextBlockInput;
};


/** Query root type */
export type QueryCouponByCodeArgs = {
  input: CouponByCodeInput;
};


/** Query root type */
export type QueryExistingCustomerArgs = {
  input: ExistingCustomerInput;
};


/** Query root type */
export type QueryLocationSuggestionsArgs = {
  input?: Maybe<LocationSuggestionsInput>;
};


/** Query root type */
export type QueryEventBySlugArgs = {
  input: EventBySlugInput;
};


/** Query root type */
export type QueryExperimentsArgs = {
  input: ExperimentsInput;
};


/** Query root type */
export type QueryBrandRecommendedProductsArgs = {
  input: BrandRecommendedProductsInput;
};


/** Query root type */
export type QueryCartUpsellRecommendationArgs = {
  input: CartUpsellRecommendationInput;
};


/** Query root type */
export type QueryCategoryRecommendedProductsArgs = {
  input: CategoryRecommendProductsInput;
};


/** Query root type */
export type QueryCoPurchasedProductsArgs = {
  input: CoPurchasedProductsInput;
};


/** Query root type */
export type QueryFrequentlyBoughtTogetherArgs = {
  input: FrequentlyBoughtTogetherInput;
};


/** Query root type */
export type QueryPeopleAlsoViewedArgs = {
  input: PeopleAlsoViewedInput;
};


/** Query root type */
export type QueryPersonalisedRecommendedProductsArgs = {
  input: PersonalisedRecommendedProductsInput;
};


/** Query root type */
export type QueryRecentlyViewedArgs = {
  input: RecentlyViewedInput;
};


/** Query root type */
export type QueryRecommendedEventsArgs = {
  input: RecommendedEventsInput;
};


/** Query root type */
export type QueryRecommendedEventsV2Args = {
  input: RecommendedEventsV2Input;
};


/** Query root type */
export type QuerySellerRecommendedProductsArgs = {
  input: SellerRecommendedProductsInput;
};


/** Query root type */
export type QuerySimilarProductsArgs = {
  input: SimilarProductsInput;
};


/** Query root type */
export type QueryTrendingProductsArgs = {
  input: TrendingProductsInput;
};

/** owner(tribe: "Digital", squad: "shopping-experience") */
export type RatingsSummary = {
  __typename?: 'RatingsSummary';
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  numberOfRatings: Scalars['Int'];
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  averageRating?: Maybe<Scalars['Float']>;
};

export type RecentlyViewedInput = {
  maximumDaysSinceViewed?: Maybe<Scalars['Int']>;
  excludePurchasedProducts?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
};

export type RecentlyViewedResponse = {
  __typename?: 'RecentlyViewedResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
};

export type RecommendedEventsInput = {
  productIds: Array<Scalars['ID']>;
  excludedEventIds?: Maybe<Array<Scalars['ID']>>;
  limit?: Maybe<Scalars['Int']>;
};

export type RecommendedEventsResponse = {
  __typename?: 'RecommendedEventsResponse';
  events: Array<Event>;
  metaData: RecommenderMetaData;
};

export type RecommendedEventsV2Input = {
  productIds: Array<Scalars['ID']>;
  excludedEventIds?: Maybe<Array<Scalars['ID']>>;
  limit?: Maybe<Scalars['Int']>;
};

export type RecommendedEventsV2Response = {
  __typename?: 'RecommendedEventsV2Response';
  events: Array<Event>;
  metaData: RecommenderMetaData;
};

/** This type hosts any metadata shared by the recommender queries */
export type RecommenderMetaData = {
  __typename?: 'RecommenderMetaData';
  postHydrationCount?: Maybe<Scalars['Int']>;
  preHydrationCount?: Maybe<Scalars['Int']>;
  hydrationErrorCount?: Maybe<Scalars['Int']>;
};

/**
 * Redeem gift card input
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type RedeemGiftCardInput = {
  /** Gift card code */
  code: Scalars['String'];
  /** Gift card pin code */
  pin: Scalars['String'];
};

export type RemoveFromWishlistItem = {
  __typename?: 'RemoveFromWishlistItem';
  id: Scalars['ID'];
};

/**
 * Remove gift card input
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type RemoveGiftCardFromCartInput = {
  /** Gift card code */
  code: Scalars['String'];
};

/**
 * Remove item from cart
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type RemoveItemFromCartInput = {
  /** CartParcelItem ID, this is ignored if an offerId is passed */
  itemId?: Maybe<Scalars['ID']>;
  offerId?: Maybe<Scalars['ID']>;
};

/** Remove item from wishlist input */
export type RemoveItemFromWishlistInput = {
  wishlistItemId: Scalars['ID'];
};

export type RemoveItemFromWishlistMutationResponse = RemoveFromWishlistItem | UserError;

/** owner(tribe: "Digital", squad: "search-and-discover") */
export type SalesChannel = {
  __typename?: 'SalesChannel';
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  id: Scalars['ID'];
};

/** owner(tribe: "Digital", squad: "shopping-experience") */
export type SalesRule = {
  __typename?: 'SalesRule';
  /** owner(tribe: "Digital", squad: "shopping-experience") */
  id: Scalars['ID'];
  /**
   * Sales rule description
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  shortDescription?: Maybe<Scalars['String']>;
  /**
   * Sales rule public description
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  longDescription?: Maybe<Scalars['String']>;
  /**
   * Sales rule public name
   * 
   * `owner(tribe: "Digital", squad: "shopping-experience")`
   */
  name?: Maybe<Scalars['String']>;
};

/** Name space for security configuration */
export type Security = {
  __typename?: 'Security';
  /** @deprecated Use more granular type instead */
  configuration?: Maybe<SecurityConfiguration>;
  /** Get frontend Kasada configuration */
  kasada: KasadaConfiguration;
};


/** Name space for security configuration */
export type SecurityKasadaArgs = {
  input: KasadaConfigurationInput;
};

export type SecurityConfiguration = {
  __typename?: 'SecurityConfiguration';
  kasada?: Maybe<KasadaConfiguration>;
};

export type SelectAddressInput = {
  addressId: Scalars['ID'];
};

/**
 * The owners of offers and organisation behind fulfilment of that offer, eg: Catch, Kmart, Agora Homewares.
 * 
 * `owner(tribe: "Digital", squad: "search-and-discover")`
 */
export type Seller = {
  __typename?: 'Seller';
  /**
   * ID of the seller
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  id: Scalars['ID'];
  /**
   * Title/name of the seller, eg: 'Catch', 'Agora Homewares', 'Matchbox Online'
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  name: Scalars['String'];
};

export type SellerRecommendedProductsInput = {
  productId?: Maybe<Scalars['ID']>;
  excludedProductIds?: Maybe<Array<Scalars['ID']>>;
  amountLeftUntilFreeShipping?: Maybe<Scalars['Int']>;
  sellerId?: Maybe<Scalars['Int']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyOnePassEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
};

export type SellerRecommendedProductsResponse = {
  __typename?: 'SellerRecommendedProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
};

export type SeoContent = {
  __typename?: 'SeoContent';
  /** The metadata title. */
  metaTitle?: Maybe<Scalars['String']>;
  /** The metadata description. */
  metaDescription?: Maybe<Scalars['String']>;
};

export type Shop = {
  __typename?: 'Shop';
  id: Scalars['Int'];
  slug: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
  pinToTop: Scalars['Boolean'];
  shopNavigationGroups: Array<ShopNavigationGroups>;
  topBrands: Array<NavigationItem>;
};

export type ShopNavigationGroups = {
  __typename?: 'ShopNavigationGroups';
  id: Scalars['Int'];
  slug: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
  shopNavigationItems: Array<NavigationItem>;
};

export type SimilarProductsInput = {
  productId?: Maybe<Scalars['ID']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  /** A value that determines which data model to be used in fetching similar products */
  modelType?: Maybe<ModelType>;
  limit?: Maybe<Scalars['Int']>;
};

export type SimilarProductsResponse = {
  __typename?: 'SimilarProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
};

/** Configuration used to connect to snowplow analytics */
export type SnowplowConfiguration = {
  __typename?: 'SnowplowConfiguration';
  collectorUrl: Scalars['String'];
  scriptSrc: Scalars['String'];
  appId: Scalars['String'];
  platform: SnowplowConfigurationPlatform;
  cookieDomain: Scalars['String'];
  eventMethod: Scalars['String'];
  pageUnloadTimer: Scalars['Int'];
  contexts: SnowplowConfigurationContexts;
};

/** Snowplow configuration context */
export type SnowplowConfigurationContexts = {
  __typename?: 'SnowplowConfigurationContexts';
  webPage: Scalars['Boolean'];
};

export type SnowplowConfigurationInput = {
  domain: Scalars['String'];
};

/** Snowplow Platform */
export type SnowplowConfigurationPlatform = 
  | 'srv'
  | 'web'
  | 'mob'
  | 'pc'
  | 'app'
  | 'tv'
  | 'cnsl'
  | 'iot';

/** Options Available for SourcePlatform */
export type SourcePlatformType = 
  | 'DESKTOP'
  | 'MOBILE'
  | 'IPAD'
  | 'IPHONE'
  | 'ANDROID';

export type StockLevel = 
  | 'NONE'
  | 'LOW'
  | 'MEDIUM'
  | 'HIGH';

/** A summary of store credit automatically applied to the Cart and any remaining balance */
export type StoreCreditSummary = {
  __typename?: 'StoreCreditSummary';
  applied: Money;
  remaining: Money;
};

/** A templated string for any notice */
export type TemplateString = {
  __typename?: 'TemplateString';
  /** Templated message eg. 'There are items in your cart that may incur additional {{ intl_shipping_link }}.' */
  template?: Maybe<Scalars['String']>;
  /** An array of placeholders used in the template */
  placeholders?: Maybe<Array<Maybe<TemplateStringPlaceholder>>>;
  /** Default string without template eg. 'There are items in your cart that may incur additional import charge.' */
  default: Scalars['String'];
};

/** Default replacement text for a TemplateString placeholder */
export type TemplateStringPlaceholder = {
  __typename?: 'TemplateStringPlaceholder';
  /** Example `intl_shipping_link` wrapped in {{}} in the template */
  id: Scalars['ID'];
  /** Text to replace the id, example 'International Seller & Import charges' */
  text: Scalars['String'];
  /** If id represents a link, this is the url of the link */
  url?: Maybe<Scalars['String']>;
};

/** Static content stored in the database */
export type TextBlock = {
  __typename?: 'TextBlock';
  key: Scalars['ID'];
  title: Scalars['String'];
  text: Scalars['String'];
};

export type TextBlockInput = {
  textBlockKey: Scalars['ID'];
};


export type ToggleDonationInput = {
  addDonation: Scalars['Boolean'];
};

/** Configuration for the top header bar above the main header */
export type TopHeaderConfiguration = {
  __typename?: 'TopHeaderConfiguration';
  leftSection: Array<TopHeaderLink>;
  rightSection: Array<TopHeaderLink>;
};

/** A link in the top header bar */
export type TopHeaderLink = {
  __typename?: 'TopHeaderLink';
  name: Scalars['String'];
  url: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  iconSize?: Maybe<Scalars['Int']>;
};

export type TrendingProductsInput = {
  productIds?: Maybe<Array<Scalars['ID']>>;
  sellerId?: Maybe<Scalars['Int']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyOnePassEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
};

export type TrendingProductsResponse = {
  __typename?: 'TrendingProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
};

/** Describes how the add to cart was triggered */
export type Trigger = 
  | 'BUY_NOW'
  | 'ADD_TO_CART';


/** Unauthorised user error type, which contain login link */
export type UnauthorisedUserError = Error & {
  __typename?: 'UnauthorisedUserError';
  message: Scalars['String'];
  /** Template that contain login link */
  messageOverride: TemplateString;
};

/**
 * Update Coupon in Cart
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type UpdateCartCouponInput = {
  code: Scalars['String'];
};

/**
 * Update the quantity of an item in the cart. If over purchaseLimit returns purchaseLimit as the quantity selected
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type UpdateCartItemQuantityInput = {
  /** CartParcelItem ID */
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

/**
 * Update cart location using either a postcode or location id
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type UpdateCartLocationInput = {
  locationId?: Maybe<Scalars['Int']>;
  postcode?: Maybe<Scalars['String']>;
};

/**
 * Update cart item product option
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type UpdateCartProductOptionInput = {
  /** CartParcelItem id */
  id: Scalars['ID'];
  /** Offer id */
  offerId: Scalars['ID'];
};

/**
 * Update cart shipping option input
 * 
 * `owner(tribe: "Digital", squad: "shopping-experience")`
 */
export type UpdateCartShippingOptionInput = {
  /** CartParcelShippingOption type */
  type: DeliveryType;
};

/** Generic user interface */
export type User = {
  /** User UUID */
  id: Scalars['ID'];
  /** First name of user */
  firstName?: Maybe<Scalars['String']>;
  /** Last name of user */
  lastName?: Maybe<Scalars['String']>;
  /** Email address of user */
  email: Scalars['EmailAddress'];
};

/** Generic user error type */
export type UserError = Error & {
  __typename?: 'UserError';
  message: Scalars['String'];
};

/**
 * A variant of a product, as each product can have one or more options, a variant is a specific permutation of the options available. ie. a variant of a golf driver may be : Left handed, 43 inch, Graphite Shaft while another might be right handed, 43 inch, steel shaft.
 * 
 * `owner(tribe: "Digital", squad: "search-and-discover")`
 */
export type Variant = {
  __typename?: 'Variant';
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  id: Scalars['ID'];
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  product: Product;
  /**
   * If the variant has offers which are in stock and available for sale.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  sellable: Scalars['Boolean'];
  /**
   * Each of the options for the product with the selected value for this variant.
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  variantOptionValues: Array<ProductOptionValue>;
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  offers: Array<Offer>;
  /**
   * owner(tribe: "Digital", squad: "search-and-discover")
   * @deprecated Use `wishlist.inWishlist` instead.
   */
  inWishlist: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  wishlist: VariantWishlist;
  /** owner(tribe: "Digital", squad: "search-and-discover") */
  bestOffer?: Maybe<Offer>;
  /**
   * Information on how the price tag should be displayed
   * 
   * `owner(tribe: "Digital", squad: "search-and-discover")`
   */
  priceTag?: Maybe<PriceTag>;
};

export type VariantWishlist = {
  __typename?: 'VariantWishlist';
  /** Is Variant in the users wishlist */
  inWishlist: Scalars['Boolean'];
  /** Full wishlist item including notify */
  wishlistItem?: Maybe<WishlistItem>;
};

/** A video type MediaAsset */
export type Video = MediaAsset & {
  __typename?: 'Video';
  id: Scalars['ID'];
  altText: Scalars['String'];
  /** Currently only YouTube URLs */
  url: Scalars['URL'];
};

export type WishlistItem = {
  __typename?: 'WishlistItem';
  id: Scalars['ID'];
  productId?: Maybe<Scalars['ID']>;
  variantId?: Maybe<Scalars['ID']>;
  notify?: Maybe<Scalars['Boolean']>;
};

export type WishlistItemMutationResponse = WishlistItem | UserError;

export type AddItemsToCartMutationVariables = Exact<{
  itemsToBeAdded: AddItemsToCartInput;
}>;


export type AddItemsToCartMutation = (
  { __typename?: 'Mutation' }
  & { addItemsToCart: (
    { __typename?: 'CartBatchMutationResponse' }
    & { cart: (
      { __typename?: 'Cart' }
      & Pick<Cart, 'itemsQuantitySum'>
    ), errors: Array<(
      { __typename?: 'CartItemError' }
      & Pick<CartItemError, 'message' | 'offerId'>
    ) | { __typename?: 'UnauthorisedUserError' } | { __typename?: 'UserError' }> }
  ) }
);

export type AddToCartMutationVariables = Exact<{
  offerId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  sourcePlatform?: Maybe<SourcePlatformType>;
  sourceId?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  sourcePosition?: Maybe<Scalars['Int']>;
}>;


export type AddToCartMutation = (
  { __typename?: 'Mutation' }
  & { addToCart: (
    { __typename?: 'Cart' }
    & CartDataFragment
  ) | (
    { __typename?: 'UserError' }
    & Pick<UserError, 'message'>
  ) | (
    { __typename?: 'UnauthorisedUserError' }
    & Pick<UnauthorisedUserError, 'message'>
  ) }
);

export type CartDataFragment = (
  { __typename?: 'Cart' }
  & Pick<Cart, 'id' | 'canProceedToCheckout' | 'itemsQuantitySum'>
  & { parcels: Array<(
    { __typename?: 'CartParcel' }
    & ParcelsDataFragment
  )>, orderSummary: (
    { __typename?: 'CartOrderSummary' }
    & OrderSummaryDataFragment
  ), notices: Array<(
    { __typename?: 'CartNotice' }
    & NoticeDataFragment
  )>, userCoupon?: Maybe<(
    { __typename?: 'CartCoupon' }
    & { coupon: (
      { __typename?: 'CartCouponMetadata' }
      & Pick<CartCouponMetadata, 'code'>
    ), notices: Array<(
      { __typename?: 'CartNotice' }
      & NoticeDataFragment
    )> }
  )>, shippingLocation?: Maybe<(
    { __typename?: 'CartShippingLocation' }
    & Pick<CartShippingLocation, 'city' | 'postcode'>
  )>, clubSubscription: (
    { __typename?: 'CartClubSubscription' }
    & Pick<CartClubSubscription, 'id' | 'offerUpsell'>
    & { options: Array<(
      { __typename?: 'CartClubSubscriptionOption' }
      & Pick<CartClubSubscriptionOption, 'id' | 'title' | 'subtitle' | 'freeTrial' | 'interval' | 'nextBillingDate'>
      & { price: (
        { __typename?: 'Money' }
        & Pick<Money, 'amount'>
      ), clubImage: (
        { __typename?: 'Image' }
        & Pick<Image, 'url'>
      ) }
    )>, selectedOption?: Maybe<(
      { __typename?: 'CartClubSubscriptionOption' }
      & Pick<CartClubSubscriptionOption, 'id' | 'title' | 'subtitle' | 'freeTrial' | 'interval' | 'nextBillingDate'>
      & { price: (
        { __typename?: 'Money' }
        & Pick<Money, 'amount'>
      ), clubImage: (
        { __typename?: 'Image' }
        & Pick<Image, 'url'>
      ) }
    )> }
  ) }
);

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = (
  { __typename?: 'Query' }
  & { cart: (
    { __typename?: 'Cart' }
    & CartDataFragment
  ) }
);

export type NoticeDataFragment = (
  { __typename?: 'CartNotice' }
  & Pick<CartNotice, 'type' | 'advisory'>
  & { message: (
    { __typename?: 'TemplateString' }
    & Pick<TemplateString, 'template' | 'default'>
    & { placeholders?: Maybe<Array<Maybe<(
      { __typename?: 'TemplateStringPlaceholder' }
      & Pick<TemplateStringPlaceholder, 'id' | 'text' | 'url'>
    )>>> }
  ) }
);

export type ClubOptionDataFragment = (
  { __typename?: 'CartClubSubscriptionOption' }
  & Pick<CartClubSubscriptionOption, 'id' | 'title' | 'subtitle' | 'freeTrial' | 'interval' | 'nextBillingDate'>
  & { price: (
    { __typename?: 'Money' }
    & Pick<Money, 'amount'>
  ), clubImage: (
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  ) }
);

export type ParcelsDataFragment = (
  { __typename?: 'CartParcel' }
  & Pick<CartParcel, 'id' | 'sellerName' | 'clubUpsellEligible' | 'marketplaceSeller'>
  & { items: Array<(
    { __typename?: 'CartParcelItem' }
    & Pick<CartParcelItem, 'id' | 'freeShipping' | 'uri' | 'quantity' | 'addedByCoupon' | 'title'>
    & { offer: (
      { __typename?: 'Offer' }
      & Pick<Offer, 'id' | 'purchasableQuantity' | 'clubFreeShipping'>
      & { originPrice?: Maybe<(
        { __typename?: 'Money' }
        & Pick<Money, 'amount'>
      )>, sellPrice: (
        { __typename?: 'Money' }
        & Pick<Money, 'amount'>
      ), variant: (
        { __typename?: 'Variant' }
        & Pick<Variant, 'inWishlist'>
        & { product: (
          { __typename?: 'Product' }
          & Pick<Product, 'id'>
          & { assets: (
            { __typename?: 'ProductAssets' }
            & { hero: (
              { __typename?: 'Image' }
              & Pick<Image, 'id' | 'url' | 'altText'>
            ) }
          ) }
        ), variantOptionValues: Array<(
          { __typename?: 'ProductOptionValue' }
          & Pick<ProductOptionValue, 'id' | 'name'>
          & { option: (
            { __typename?: 'ProductOption' }
            & Pick<ProductOption, 'name'>
          ) }
        )> }
      ) }
    ), totalPrice: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount'>
    ), personalisedValues: Array<(
      { __typename?: 'PersonalisedValue' }
      & Pick<PersonalisedValue, 'label' | 'value'>
    )>, notices: Array<(
      { __typename?: 'CartNotice' }
      & NoticeDataFragment
    )>, metadata: (
      { __typename?: 'CartParcelItemMetadata' }
      & Pick<CartParcelItemMetadata, 'sourcePosition' | 'sourceType' | 'eventId'>
    ) }
  )>, dispatchNotice?: Maybe<(
    { __typename?: 'CartParcelDispatchNotice' }
    & Pick<CartParcelDispatchNotice, 'message' | 'type'>
  )>, selectedShippingOption?: Maybe<(
    { __typename?: 'CartParcelShippingOption' }
    & Pick<CartParcelShippingOption, 'id' | 'type' | 'locationType' | 'title' | 'clubFreeShipping'>
    & { price: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount' | 'currency'>
    ) }
  )>, shippingOptions: Array<(
    { __typename?: 'CartParcelShippingOption' }
    & Pick<CartParcelShippingOption, 'id' | 'type' | 'locationType' | 'title' | 'attentionTag' | 'clubFreeShipping'>
    & { price: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount' | 'currency'>
    ) }
  )>, subtotalPrice: (
    { __typename?: 'Money' }
    & Pick<Money, 'amount'>
  ) }
);

export type ParcelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ParcelsQuery = (
  { __typename?: 'Query' }
  & { cart: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'id' | 'itemsQuantitySum'>
    & { parcels: Array<(
      { __typename?: 'CartParcel' }
      & ParcelsDataFragment
    )>, shippingLocation?: Maybe<(
      { __typename?: 'CartShippingLocation' }
      & Pick<CartShippingLocation, 'city' | 'postcode'>
    )>, clubSubscription: (
      { __typename?: 'CartClubSubscription' }
      & Pick<CartClubSubscription, 'id' | 'offerUpsell'>
      & { options: Array<(
        { __typename?: 'CartClubSubscriptionOption' }
        & Pick<CartClubSubscriptionOption, 'id' | 'title' | 'subtitle' | 'freeTrial' | 'interval' | 'nextBillingDate'>
        & { price: (
          { __typename?: 'Money' }
          & Pick<Money, 'amount'>
        ), clubImage: (
          { __typename?: 'Image' }
          & Pick<Image, 'url'>
        ) }
      )>, selectedOption?: Maybe<(
        { __typename?: 'CartClubSubscriptionOption' }
        & Pick<CartClubSubscriptionOption, 'id' | 'title' | 'subtitle' | 'freeTrial' | 'interval' | 'nextBillingDate'>
        & { price: (
          { __typename?: 'Money' }
          & Pick<Money, 'amount'>
        ), clubImage: (
          { __typename?: 'Image' }
          & Pick<Image, 'url'>
        ) }
      )> }
    ), orderSummary: (
      { __typename?: 'CartOrderSummary' }
      & Pick<CartOrderSummary, 'id'>
    ), notices: Array<(
      { __typename?: 'CartNotice' }
      & NoticeDataFragment
    )> }
  ) }
);

export type CartUpsellRecommendationQueryVariables = Exact<{
  productIds: Array<Scalars['ID']>;
}>;


export type CartUpsellRecommendationQuery = (
  { __typename?: 'Query' }
  & { cartUpsellRecommendation: (
    { __typename?: 'CartUpsellResponse' }
    & { product?: Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'id' | 'title'>
      & { bestOffer?: Maybe<(
        { __typename?: 'Offer' }
        & Pick<Offer, 'id' | 'purchasableQuantity'>
        & { variant: (
          { __typename?: 'Variant' }
          & Pick<Variant, 'inWishlist'>
          & { product: (
            { __typename?: 'Product' }
            & { assets: (
              { __typename?: 'ProductAssets' }
              & { hero: (
                { __typename?: 'Image' }
                & Pick<Image, 'id' | 'url' | 'altText'>
              ) }
            ) }
          ) }
        ), sellPrice: (
          { __typename?: 'Money' }
          & Pick<Money, 'amount'>
        ) }
      )> }
    )>, metaData: (
      { __typename?: 'RecommenderMetaData' }
      & Pick<RecommenderMetaData, 'preHydrationCount' | 'postHydrationCount' | 'hydrationErrorCount'>
    ) }
  ) }
);

export type UpdateCartShippingOptionMutationVariables = Exact<{
  type: DeliveryType;
}>;


export type UpdateCartShippingOptionMutation = (
  { __typename?: 'Mutation' }
  & { updateCartShippingOption: (
    { __typename?: 'Cart' }
    & CartDataFragment
  ) | (
    { __typename?: 'UserError' }
    & Pick<UserError, 'message'>
  ) | { __typename?: 'UnauthorisedUserError' } }
);

export type UpdateCartItemQuantityMutationVariables = Exact<{
  id: Scalars['ID'];
  quantity: Scalars['Int'];
}>;


export type UpdateCartItemQuantityMutation = (
  { __typename?: 'Mutation' }
  & { updateCartItemQuantity: (
    { __typename?: 'Cart' }
    & CartDataFragment
  ) | (
    { __typename?: 'UserError' }
    & Pick<UserError, 'message'>
  ) | (
    { __typename?: 'UnauthorisedUserError' }
    & Pick<UnauthorisedUserError, 'message'>
  ) }
);

export type RemoveItemFromCartMutationVariables = Exact<{
  itemId?: Maybe<Scalars['ID']>;
  offerId?: Maybe<Scalars['ID']>;
}>;


export type RemoveItemFromCartMutation = (
  { __typename?: 'Mutation' }
  & { removeItemFromCart: (
    { __typename?: 'Cart' }
    & CartDataFragment
  ) | (
    { __typename?: 'UserError' }
    & Pick<UserError, 'message'>
  ) | { __typename?: 'UnauthorisedUserError' } }
);

export type MoveItemFromCartToWishlistMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MoveItemFromCartToWishlistMutation = (
  { __typename?: 'Mutation' }
  & { moveItemFromCartToWishlist: (
    { __typename?: 'Cart' }
    & CartDataFragment
  ) | (
    { __typename?: 'UserError' }
    & Pick<UserError, 'message'>
  ) | { __typename?: 'UnauthorisedUserError' } }
);

export type CheckoutNoticeDataFragment = (
  { __typename?: 'CheckoutNotice' }
  & Pick<CheckoutNotice, 'type' | 'advisory'>
  & { message: (
    { __typename?: 'TemplateString' }
    & Pick<TemplateString, 'template' | 'default'>
    & { placeholders?: Maybe<Array<Maybe<(
      { __typename?: 'TemplateStringPlaceholder' }
      & Pick<TemplateStringPlaceholder, 'id' | 'text' | 'url'>
    )>>> }
  ) }
);

export type PaymentMethodDataFragment = (
  { __typename?: 'PaymentMethod' }
  & Pick<PaymentMethod, 'type' | 'description' | 'imageSrc'>
);

export type CheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutQuery = (
  { __typename?: 'Query' }
  & { checkout: (
    { __typename?: 'Checkout' }
    & Pick<Checkout, 'id' | 'express'>
    & { customer?: Maybe<(
      { __typename?: 'Customer' }
      & Pick<Customer, 'id' | 'email'>
    )>, cart: (
      { __typename?: 'Cart' }
      & Pick<Cart, 'id' | 'itemsQuantitySum'>
      & { parcels: Array<(
        { __typename?: 'CartParcel' }
        & ParcelsDataFragment
      )>, shippingLocation?: Maybe<(
        { __typename?: 'CartShippingLocation' }
        & Pick<CartShippingLocation, 'city' | 'postcode'>
      )>, orderSummary: (
        { __typename?: 'CartOrderSummary' }
        & Pick<CartOrderSummary, 'id'>
      ) }
    ), selectedAddress?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'id' | 'company' | 'firstName' | 'lastName' | 'streetAddress' | 'streetAddress2' | 'postcode' | 'city' | 'country' | 'state' | 'stateShort' | 'phoneNumber' | 'deliveryLocationType' | 'deliveryLocationName'>
    )>, notices: Array<(
      { __typename?: 'CheckoutNotice' }
      & CheckoutNoticeDataFragment
    )>, paymentMethods: Array<(
      { __typename?: 'PaymentMethod' }
      & PaymentMethodDataFragment
    )>, selectedPaymentMethod?: Maybe<(
      { __typename?: 'PaymentMethod' }
      & PaymentMethodDataFragment
    )> }
  ) }
);

export type ExistingCustomerQueryVariables = Exact<{
  email: Scalars['EmailAddress'];
}>;


export type ExistingCustomerQuery = (
  { __typename?: 'Query' }
  & { existingCustomer: (
    { __typename: 'ExistingCustomer' }
    & Pick<ExistingCustomer, 'exists'>
  ) | (
    { __typename: 'UserError' }
    & Pick<UserError, 'message'>
  ) }
);

export type UserCouponQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCouponQuery = (
  { __typename?: 'Query' }
  & { cart: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'id'>
    & { userCoupon?: Maybe<(
      { __typename?: 'CartCoupon' }
      & { coupon: (
        { __typename?: 'CartCouponMetadata' }
        & Pick<CartCouponMetadata, 'code'>
      ), notices: Array<(
        { __typename?: 'CartNotice' }
        & NoticeDataFragment
      )> }
    )>, orderSummary: (
      { __typename?: 'CartOrderSummary' }
      & Pick<CartOrderSummary, 'id'>
      & { totalSaving: (
        { __typename?: 'Money' }
        & Pick<Money, 'amount'>
      ) }
    ) }
  ) }
);

export type UpdateCartCouponMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type UpdateCartCouponMutation = (
  { __typename?: 'Mutation' }
  & { updateCartCoupon: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'id'>
    & { notices: Array<(
      { __typename?: 'CartNotice' }
      & NoticeDataFragment
    )>, orderSummary: (
      { __typename?: 'CartOrderSummary' }
      & OrderSummaryDataFragment
    ), userCoupon?: Maybe<(
      { __typename?: 'CartCoupon' }
      & { coupon: (
        { __typename?: 'CartCouponMetadata' }
        & Pick<CartCouponMetadata, 'code'>
      ) }
    )> }
  ) | (
    { __typename?: 'UserError' }
    & Pick<UserError, 'message'>
  ) | (
    { __typename?: 'UnauthorisedUserError' }
    & { messageOverride: (
      { __typename?: 'TemplateString' }
      & Pick<TemplateString, 'template' | 'default'>
      & { placeholders?: Maybe<Array<Maybe<(
        { __typename?: 'TemplateStringPlaceholder' }
        & Pick<TemplateStringPlaceholder, 'id' | 'text' | 'url'>
      )>>> }
    ) }
  ) }
);

export type ToggleDonationMutationVariables = Exact<{
  add: Scalars['Boolean'];
}>;


export type ToggleDonationMutation = (
  { __typename?: 'Mutation' }
  & { toggleDonation: (
    { __typename?: 'Cart' }
    & { orderSummary: (
      { __typename?: 'CartOrderSummary' }
      & OrderSummaryDataFragment
    ) }
  ) | (
    { __typename?: 'UserError' }
    & Pick<UserError, 'message'>
  ) | (
    { __typename?: 'UnauthorisedUserError' }
    & Pick<UnauthorisedUserError, 'message'>
  ) }
);

export type RedeemGiftCardMutationVariables = Exact<{
  giftCard: RedeemGiftCardInput;
}>;


export type RedeemGiftCardMutation = (
  { __typename?: 'Mutation' }
  & { redeemGiftCard: (
    { __typename: 'Cart' }
    & { notices: Array<(
      { __typename?: 'CartNotice' }
      & NoticeDataFragment
    )>, orderSummary: (
      { __typename?: 'CartOrderSummary' }
      & OrderSummaryDataFragment
    ) }
  ) | (
    { __typename: 'UserError' }
    & Pick<UserError, 'message'>
  ) | (
    { __typename: 'UnauthorisedUserError' }
    & Pick<UnauthorisedUserError, 'message'>
  ) }
);

export type OrderSummaryDataFragment = (
  { __typename?: 'CartOrderSummary' }
  & Pick<CartOrderSummary, 'id' | 'ageConfirmationRequired'>
  & { totalSaving: (
    { __typename?: 'Money' }
    & Pick<Money, 'amount'>
  ), itemSummary: (
    { __typename?: 'OrderSummaryItems' }
    & { total: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount'>
    ), items: Array<(
      { __typename?: 'CartParcelItem' }
      & Pick<CartParcelItem, 'id' | 'uri' | 'quantity' | 'addedByCoupon' | 'title'>
      & { totalPrice: (
        { __typename?: 'Money' }
        & Pick<Money, 'amount'>
      ), offer: (
        { __typename?: 'Offer' }
        & Pick<Offer, 'id' | 'purchasableQuantity' | 'clubFreeShipping'>
        & { originPrice?: Maybe<(
          { __typename?: 'Money' }
          & Pick<Money, 'amount'>
        )>, sellPrice: (
          { __typename?: 'Money' }
          & Pick<Money, 'amount'>
        ), variant: (
          { __typename?: 'Variant' }
          & Pick<Variant, 'inWishlist'>
          & { product: (
            { __typename?: 'Product' }
            & Pick<Product, 'id'>
            & { assets: (
              { __typename?: 'ProductAssets' }
              & { hero: (
                { __typename?: 'Image' }
                & Pick<Image, 'id' | 'url' | 'altText'>
              ) }
            ) }
          ), variantOptionValues: Array<(
            { __typename?: 'ProductOptionValue' }
            & Pick<ProductOptionValue, 'id' | 'name'>
            & { option: (
              { __typename?: 'ProductOption' }
              & Pick<ProductOption, 'name'>
            ) }
          )> }
        ) }
      ), metadata: (
        { __typename?: 'CartParcelItemMetadata' }
        & Pick<CartParcelItemMetadata, 'eventId' | 'sourcePosition' | 'sourceType'>
      ) }
    )> }
  ), delivery?: Maybe<(
    { __typename?: 'OrderSummaryDelivery' }
    & Pick<OrderSummaryDelivery, 'deliveryType'>
    & { total: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount'>
    ) }
  )>, donation?: Maybe<(
    { __typename?: 'OrderSummaryDonation' }
    & Pick<OrderSummaryDonation, 'organisationName' | 'body' | 'header'>
    & { total: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount'>
    ), image: (
      { __typename?: 'Image' }
      & Pick<Image, 'url' | 'altText'>
    ), orderTotalBefore: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount' | 'currency'>
    ), orderTotalAfter: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount' | 'currency'>
    ) }
  )>, giftCards: Array<(
    { __typename?: 'OrderSummaryGiftCard' }
    & Pick<OrderSummaryGiftCard, 'code'>
    & { appliedBalance: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount'>
    ), remainingBalance: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount'>
    ) }
  )>, discounts: Array<(
    { __typename?: 'OrderSummaryDiscount' }
    & Pick<OrderSummaryDiscount, 'label' | 'deletable'>
    & { discount: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount'>
    ) }
  )>, storeCredit?: Maybe<(
    { __typename?: 'StoreCreditSummary' }
    & { applied: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount'>
    ), remaining: (
      { __typename?: 'Money' }
      & Pick<Money, 'amount'>
    ) }
  )>, subtotalPrice: (
    { __typename?: 'Money' }
    & Pick<Money, 'amount'>
  ), totalPrice: (
    { __typename?: 'Money' }
    & Pick<Money, 'amount'>
  ) }
);

export type OrderSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderSummaryQuery = (
  { __typename?: 'Query' }
  & { cart: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'id' | 'itemsQuantitySum' | 'canProceedToCheckout' | 'giftCardSupported'>
    & { parcels: Array<(
      { __typename?: 'CartParcel' }
      & Pick<CartParcel, 'id'>
    )>, orderSummary: (
      { __typename?: 'CartOrderSummary' }
      & OrderSummaryDataFragment
    ), clubSubscription: (
      { __typename?: 'CartClubSubscription' }
      & { selectedOption?: Maybe<(
        { __typename?: 'CartClubSubscriptionOption' }
        & Pick<CartClubSubscriptionOption, 'id'>
        & { price: (
          { __typename?: 'Money' }
          & Pick<Money, 'amount'>
        ) }
      )> }
    ) }
  ) }
);

export type RemoveCouponFromCartMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveCouponFromCartMutation = (
  { __typename?: 'Mutation' }
  & { removeCouponFromCart: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'id'>
    & { notices: Array<(
      { __typename?: 'CartNotice' }
      & NoticeDataFragment
    )>, orderSummary: (
      { __typename?: 'CartOrderSummary' }
      & OrderSummaryDataFragment
    ), userCoupon?: Maybe<(
      { __typename?: 'CartCoupon' }
      & { coupon: (
        { __typename?: 'CartCouponMetadata' }
        & Pick<CartCouponMetadata, 'code'>
      ) }
    )> }
  ) | (
    { __typename?: 'UserError' }
    & Pick<UserError, 'message'>
  ) | { __typename?: 'UnauthorisedUserError' } }
);

export type RemoveGiftCardFromCartMutationVariables = Exact<{
  giftCardCode: Scalars['String'];
}>;


export type RemoveGiftCardFromCartMutation = (
  { __typename?: 'Mutation' }
  & { removeGiftCardFromCart: (
    { __typename: 'Cart' }
    & Pick<Cart, 'id'>
    & { notices: Array<(
      { __typename?: 'CartNotice' }
      & NoticeDataFragment
    )>, orderSummary: (
      { __typename?: 'CartOrderSummary' }
      & OrderSummaryDataFragment
    ) }
  ) | (
    { __typename: 'UserError' }
    & Pick<UserError, 'message'>
  ) | (
    { __typename: 'UnauthorisedUserError' }
    & Pick<UnauthorisedUserError, 'message'>
  ) }
);

export type GetLocationSuggestionsQueryVariables = Exact<{
  searchTerm?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
}>;


export type GetLocationSuggestionsQuery = (
  { __typename?: 'Query' }
  & { locationSuggestions: (
    { __typename?: 'LocationSuggestionsResult' }
    & { postcodes: Array<(
      { __typename?: 'Location' }
      & Pick<Location, 'id' | 'postcode' | 'suburb' | 'state' | 'country'>
    )> }
  ) }
);

export type UpdateCartLocationMutationVariables = Exact<{
  locationId: Scalars['Int'];
}>;


export type UpdateCartLocationMutation = (
  { __typename?: 'Mutation' }
  & { updateCartLocation: (
    { __typename?: 'Cart' }
    & CartDataFragment
  ) | (
    { __typename?: 'UserError' }
    & Pick<UserError, 'message'>
  ) | { __typename?: 'UnauthorisedUserError' } }
);

export const NoticeDataFragmentDoc = gql`
    fragment NoticeData on CartNotice {
  message {
    template
    placeholders {
      id
      text
      url
    }
    default
  }
  type
  advisory
}
    `;
export const ParcelsDataFragmentDoc = gql`
    fragment ParcelsData on CartParcel {
  id
  sellerName
  clubUpsellEligible
  marketplaceSeller
  items {
    id
    offer {
      id
      purchasableQuantity
      clubFreeShipping
      originPrice {
        amount
      }
      sellPrice {
        amount
      }
      variant {
        inWishlist
        product {
          id
          assets {
            hero {
              id
              url
              altText
            }
          }
        }
        variantOptionValues {
          id
          name
          option {
            name
          }
        }
      }
    }
    freeShipping
    uri
    quantity
    totalPrice {
      amount
    }
    addedByCoupon
    title
    personalisedValues {
      label
      value
    }
    notices {
      ...NoticeData
    }
    metadata {
      sourcePosition
      sourceType
      eventId
    }
  }
  dispatchNotice {
    message
    type
  }
  selectedShippingOption {
    id
    price {
      amount
      currency
    }
    type
    locationType
    title
    clubFreeShipping
  }
  shippingOptions {
    id
    type
    locationType
    title
    price {
      amount
      currency
    }
    attentionTag
    clubFreeShipping
  }
  subtotalPrice {
    amount
  }
}
    ${NoticeDataFragmentDoc}`;
export const OrderSummaryDataFragmentDoc = gql`
    fragment OrderSummaryData on CartOrderSummary {
  id
  totalSaving {
    amount
  }
  itemSummary {
    total {
      amount
    }
    items {
      id
      uri
      quantity
      totalPrice {
        amount
      }
      addedByCoupon
      title
      offer {
        id
        purchasableQuantity
        clubFreeShipping
        originPrice {
          amount
        }
        sellPrice {
          amount
        }
        variant {
          inWishlist
          product {
            id
            assets {
              hero {
                id
                url
                altText
              }
            }
          }
          variantOptionValues {
            id
            name
            option {
              name
            }
          }
        }
      }
      metadata {
        eventId
        sourcePosition
        sourceType
      }
    }
  }
  delivery {
    total {
      amount
    }
    deliveryType
  }
  donation {
    total {
      amount
    }
    organisationName
    image {
      url
      altText
    }
    body
    header
    orderTotalBefore {
      amount
      currency
    }
    orderTotalAfter {
      amount
      currency
    }
  }
  giftCards {
    code
    appliedBalance {
      amount
    }
    remainingBalance {
      amount
    }
  }
  discounts {
    discount {
      amount
    }
    label
    deletable
  }
  storeCredit {
    applied {
      amount
    }
    remaining {
      amount
    }
  }
  ageConfirmationRequired
  subtotalPrice {
    amount
  }
  totalPrice {
    amount
  }
}
    `;
export const CartDataFragmentDoc = gql`
    fragment CartData on Cart {
  id
  canProceedToCheckout
  parcels {
    ...ParcelsData
  }
  orderSummary {
    ...OrderSummaryData
  }
  notices {
    ...NoticeData
  }
  itemsQuantitySum
  userCoupon {
    coupon {
      code
    }
    notices {
      ...NoticeData
    }
  }
  shippingLocation {
    city
    postcode
  }
  clubSubscription {
    id
    offerUpsell
    options {
      id
      title
      subtitle
      freeTrial
      interval
      nextBillingDate
      price {
        amount
      }
      clubImage {
        url
      }
    }
    selectedOption {
      id
      title
      subtitle
      freeTrial
      interval
      nextBillingDate
      price {
        amount
      }
      clubImage {
        url
      }
    }
  }
}
    ${ParcelsDataFragmentDoc}
${OrderSummaryDataFragmentDoc}
${NoticeDataFragmentDoc}`;
export const ClubOptionDataFragmentDoc = gql`
    fragment ClubOptionData on CartClubSubscriptionOption {
  id
  title
  subtitle
  freeTrial
  interval
  nextBillingDate
  price {
    amount
  }
  clubImage {
    url
  }
}
    `;
export const CheckoutNoticeDataFragmentDoc = gql`
    fragment CheckoutNoticeData on CheckoutNotice {
  message {
    template
    placeholders {
      id
      text
      url
    }
    default
  }
  type
  advisory
}
    `;
export const PaymentMethodDataFragmentDoc = gql`
    fragment PaymentMethodData on PaymentMethod {
  type
  description
  imageSrc
}
    `;
export const AddItemsToCartDocument = gql`
    mutation AddItemsToCart($itemsToBeAdded: AddItemsToCartInput!) {
  addItemsToCart(input: $itemsToBeAdded) {
    cart {
      itemsQuantitySum
    }
    errors {
      ... on CartItemError {
        message
        offerId
      }
    }
  }
}
    `;
export type AddItemsToCartMutationFn = Apollo.MutationFunction<AddItemsToCartMutation, AddItemsToCartMutationVariables>;

/**
 * __useAddItemsToCartMutation__
 *
 * To run a mutation, you first call `useAddItemsToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemsToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemsToCartMutation, { data, loading, error }] = useAddItemsToCartMutation({
 *   variables: {
 *      itemsToBeAdded: // value for 'itemsToBeAdded'
 *   },
 * });
 */
export function useAddItemsToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddItemsToCartMutation, AddItemsToCartMutationVariables>) {
        return Apollo.useMutation<AddItemsToCartMutation, AddItemsToCartMutationVariables>(AddItemsToCartDocument, baseOptions);
      }
export type AddItemsToCartMutationHookResult = ReturnType<typeof useAddItemsToCartMutation>;
export type AddItemsToCartMutationResult = Apollo.MutationResult<AddItemsToCartMutation>;
export type AddItemsToCartMutationOptions = Apollo.BaseMutationOptions<AddItemsToCartMutation, AddItemsToCartMutationVariables>;
export const AddToCartDocument = gql`
    mutation AddToCart($offerId: ID!, $quantity: Int, $sourcePlatform: SourcePlatformType, $sourceId: String, $sourceType: String, $sourcePosition: Int) {
  addToCart(input: {offerId: $offerId, quantity: $quantity, sourcePlatform: $sourcePlatform, sourceId: $sourceId, sourceType: $sourceType, sourcePosition: $sourcePosition}) {
    ... on Error {
      message
    }
    ... on Cart {
      ...CartData
    }
  }
}
    ${CartDataFragmentDoc}`;
export type AddToCartMutationFn = Apollo.MutationFunction<AddToCartMutation, AddToCartMutationVariables>;

/**
 * __useAddToCartMutation__
 *
 * To run a mutation, you first call `useAddToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToCartMutation, { data, loading, error }] = useAddToCartMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      quantity: // value for 'quantity'
 *      sourcePlatform: // value for 'sourcePlatform'
 *      sourceId: // value for 'sourceId'
 *      sourceType: // value for 'sourceType'
 *      sourcePosition: // value for 'sourcePosition'
 *   },
 * });
 */
export function useAddToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddToCartMutation, AddToCartMutationVariables>) {
        return Apollo.useMutation<AddToCartMutation, AddToCartMutationVariables>(AddToCartDocument, baseOptions);
      }
export type AddToCartMutationHookResult = ReturnType<typeof useAddToCartMutation>;
export type AddToCartMutationResult = Apollo.MutationResult<AddToCartMutation>;
export type AddToCartMutationOptions = Apollo.BaseMutationOptions<AddToCartMutation, AddToCartMutationVariables>;
export const CartDocument = gql`
    query Cart {
  cart {
    ...CartData
  }
}
    ${CartDataFragmentDoc}`;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartQuery(baseOptions?: Apollo.QueryHookOptions<CartQuery, CartQueryVariables>) {
        return Apollo.useQuery<CartQuery, CartQueryVariables>(CartDocument, baseOptions);
      }
export function useCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          return Apollo.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, baseOptions);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const ParcelsDocument = gql`
    query Parcels {
  cart {
    id
    itemsQuantitySum
    parcels {
      ...ParcelsData
    }
    shippingLocation {
      city
      postcode
    }
    clubSubscription {
      id
      offerUpsell
      options {
        id
        title
        subtitle
        freeTrial
        interval
        nextBillingDate
        price {
          amount
        }
        clubImage {
          url
        }
      }
      selectedOption {
        id
        title
        subtitle
        freeTrial
        interval
        nextBillingDate
        price {
          amount
        }
        clubImage {
          url
        }
      }
    }
    orderSummary {
      id
    }
    notices {
      ...NoticeData
    }
  }
}
    ${ParcelsDataFragmentDoc}
${NoticeDataFragmentDoc}`;

/**
 * __useParcelsQuery__
 *
 * To run a query within a React component, call `useParcelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParcelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParcelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useParcelsQuery(baseOptions?: Apollo.QueryHookOptions<ParcelsQuery, ParcelsQueryVariables>) {
        return Apollo.useQuery<ParcelsQuery, ParcelsQueryVariables>(ParcelsDocument, baseOptions);
      }
export function useParcelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParcelsQuery, ParcelsQueryVariables>) {
          return Apollo.useLazyQuery<ParcelsQuery, ParcelsQueryVariables>(ParcelsDocument, baseOptions);
        }
export type ParcelsQueryHookResult = ReturnType<typeof useParcelsQuery>;
export type ParcelsLazyQueryHookResult = ReturnType<typeof useParcelsLazyQuery>;
export type ParcelsQueryResult = Apollo.QueryResult<ParcelsQuery, ParcelsQueryVariables>;
export const CartUpsellRecommendationDocument = gql`
    query CartUpsellRecommendation($productIds: [ID!]!) {
  cartUpsellRecommendation(input: {productIds: $productIds}) {
    product {
      id
      title
      bestOffer {
        id
        variant {
          inWishlist
          product {
            assets {
              hero {
                id
                url
                altText
              }
            }
          }
        }
        purchasableQuantity
        sellPrice {
          amount
        }
      }
    }
    metaData {
      preHydrationCount
      postHydrationCount
      hydrationErrorCount
    }
  }
}
    `;

/**
 * __useCartUpsellRecommendationQuery__
 *
 * To run a query within a React component, call `useCartUpsellRecommendationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartUpsellRecommendationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartUpsellRecommendationQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useCartUpsellRecommendationQuery(baseOptions?: Apollo.QueryHookOptions<CartUpsellRecommendationQuery, CartUpsellRecommendationQueryVariables>) {
        return Apollo.useQuery<CartUpsellRecommendationQuery, CartUpsellRecommendationQueryVariables>(CartUpsellRecommendationDocument, baseOptions);
      }
export function useCartUpsellRecommendationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartUpsellRecommendationQuery, CartUpsellRecommendationQueryVariables>) {
          return Apollo.useLazyQuery<CartUpsellRecommendationQuery, CartUpsellRecommendationQueryVariables>(CartUpsellRecommendationDocument, baseOptions);
        }
export type CartUpsellRecommendationQueryHookResult = ReturnType<typeof useCartUpsellRecommendationQuery>;
export type CartUpsellRecommendationLazyQueryHookResult = ReturnType<typeof useCartUpsellRecommendationLazyQuery>;
export type CartUpsellRecommendationQueryResult = Apollo.QueryResult<CartUpsellRecommendationQuery, CartUpsellRecommendationQueryVariables>;
export const UpdateCartShippingOptionDocument = gql`
    mutation UpdateCartShippingOption($type: DeliveryType!) {
  updateCartShippingOption(input: {type: $type}) {
    ... on Cart {
      ...CartData
    }
    ... on UserError {
      message
    }
  }
}
    ${CartDataFragmentDoc}`;
export type UpdateCartShippingOptionMutationFn = Apollo.MutationFunction<UpdateCartShippingOptionMutation, UpdateCartShippingOptionMutationVariables>;

/**
 * __useUpdateCartShippingOptionMutation__
 *
 * To run a mutation, you first call `useUpdateCartShippingOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartShippingOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartShippingOptionMutation, { data, loading, error }] = useUpdateCartShippingOptionMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateCartShippingOptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartShippingOptionMutation, UpdateCartShippingOptionMutationVariables>) {
        return Apollo.useMutation<UpdateCartShippingOptionMutation, UpdateCartShippingOptionMutationVariables>(UpdateCartShippingOptionDocument, baseOptions);
      }
export type UpdateCartShippingOptionMutationHookResult = ReturnType<typeof useUpdateCartShippingOptionMutation>;
export type UpdateCartShippingOptionMutationResult = Apollo.MutationResult<UpdateCartShippingOptionMutation>;
export type UpdateCartShippingOptionMutationOptions = Apollo.BaseMutationOptions<UpdateCartShippingOptionMutation, UpdateCartShippingOptionMutationVariables>;
export const UpdateCartItemQuantityDocument = gql`
    mutation UpdateCartItemQuantity($id: ID!, $quantity: Int!) {
  updateCartItemQuantity(input: {id: $id, quantity: $quantity}) {
    ... on Error {
      message
    }
    ... on Cart {
      ...CartData
    }
  }
}
    ${CartDataFragmentDoc}`;
export type UpdateCartItemQuantityMutationFn = Apollo.MutationFunction<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>;

/**
 * __useUpdateCartItemQuantityMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemQuantityMutation, { data, loading, error }] = useUpdateCartItemQuantityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdateCartItemQuantityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>) {
        return Apollo.useMutation<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>(UpdateCartItemQuantityDocument, baseOptions);
      }
export type UpdateCartItemQuantityMutationHookResult = ReturnType<typeof useUpdateCartItemQuantityMutation>;
export type UpdateCartItemQuantityMutationResult = Apollo.MutationResult<UpdateCartItemQuantityMutation>;
export type UpdateCartItemQuantityMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>;
export const RemoveItemFromCartDocument = gql`
    mutation RemoveItemFromCart($itemId: ID, $offerId: ID) {
  removeItemFromCart(input: {itemId: $itemId, offerId: $offerId}) {
    ... on Cart {
      ...CartData
    }
    ... on UserError {
      message
    }
  }
}
    ${CartDataFragmentDoc}`;
export type RemoveItemFromCartMutationFn = Apollo.MutationFunction<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>;

/**
 * __useRemoveItemFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveItemFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemFromCartMutation, { data, loading, error }] = useRemoveItemFromCartMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useRemoveItemFromCartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>) {
        return Apollo.useMutation<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(RemoveItemFromCartDocument, baseOptions);
      }
export type RemoveItemFromCartMutationHookResult = ReturnType<typeof useRemoveItemFromCartMutation>;
export type RemoveItemFromCartMutationResult = Apollo.MutationResult<RemoveItemFromCartMutation>;
export type RemoveItemFromCartMutationOptions = Apollo.BaseMutationOptions<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>;
export const MoveItemFromCartToWishlistDocument = gql`
    mutation MoveItemFromCartToWishlist($id: ID!) {
  moveItemFromCartToWishlist(input: {id: $id}) {
    ... on Cart {
      ...CartData
    }
    ... on UserError {
      message
    }
  }
}
    ${CartDataFragmentDoc}`;
export type MoveItemFromCartToWishlistMutationFn = Apollo.MutationFunction<MoveItemFromCartToWishlistMutation, MoveItemFromCartToWishlistMutationVariables>;

/**
 * __useMoveItemFromCartToWishlistMutation__
 *
 * To run a mutation, you first call `useMoveItemFromCartToWishlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveItemFromCartToWishlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveItemFromCartToWishlistMutation, { data, loading, error }] = useMoveItemFromCartToWishlistMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMoveItemFromCartToWishlistMutation(baseOptions?: Apollo.MutationHookOptions<MoveItemFromCartToWishlistMutation, MoveItemFromCartToWishlistMutationVariables>) {
        return Apollo.useMutation<MoveItemFromCartToWishlistMutation, MoveItemFromCartToWishlistMutationVariables>(MoveItemFromCartToWishlistDocument, baseOptions);
      }
export type MoveItemFromCartToWishlistMutationHookResult = ReturnType<typeof useMoveItemFromCartToWishlistMutation>;
export type MoveItemFromCartToWishlistMutationResult = Apollo.MutationResult<MoveItemFromCartToWishlistMutation>;
export type MoveItemFromCartToWishlistMutationOptions = Apollo.BaseMutationOptions<MoveItemFromCartToWishlistMutation, MoveItemFromCartToWishlistMutationVariables>;
export const CheckoutDocument = gql`
    query Checkout {
  checkout {
    id
    customer {
      id
      email
    }
    cart {
      id
      itemsQuantitySum
      parcels {
        ...ParcelsData
      }
      shippingLocation {
        city
        postcode
      }
      orderSummary {
        id
      }
    }
    selectedAddress {
      id
      company
      firstName
      lastName
      streetAddress
      streetAddress2
      postcode
      city
      country
      state
      stateShort
      phoneNumber
      deliveryLocationType
      deliveryLocationName
    }
    notices {
      ...CheckoutNoticeData
    }
    paymentMethods {
      ...PaymentMethodData
    }
    selectedPaymentMethod {
      ...PaymentMethodData
    }
    express
  }
}
    ${ParcelsDataFragmentDoc}
${CheckoutNoticeDataFragmentDoc}
${PaymentMethodDataFragmentDoc}`;

/**
 * __useCheckoutQuery__
 *
 * To run a query within a React component, call `useCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckoutQuery(baseOptions?: Apollo.QueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
        return Apollo.useQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, baseOptions);
      }
export function useCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
          return Apollo.useLazyQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, baseOptions);
        }
export type CheckoutQueryHookResult = ReturnType<typeof useCheckoutQuery>;
export type CheckoutLazyQueryHookResult = ReturnType<typeof useCheckoutLazyQuery>;
export type CheckoutQueryResult = Apollo.QueryResult<CheckoutQuery, CheckoutQueryVariables>;
export const ExistingCustomerDocument = gql`
    query ExistingCustomer($email: EmailAddress!) {
  existingCustomer(input: {email: $email}) {
    __typename
    ... on ExistingCustomer {
      exists
    }
    ... on UserError {
      message
    }
  }
}
    `;

/**
 * __useExistingCustomerQuery__
 *
 * To run a query within a React component, call `useExistingCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistingCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistingCustomerQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useExistingCustomerQuery(baseOptions?: Apollo.QueryHookOptions<ExistingCustomerQuery, ExistingCustomerQueryVariables>) {
        return Apollo.useQuery<ExistingCustomerQuery, ExistingCustomerQueryVariables>(ExistingCustomerDocument, baseOptions);
      }
export function useExistingCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExistingCustomerQuery, ExistingCustomerQueryVariables>) {
          return Apollo.useLazyQuery<ExistingCustomerQuery, ExistingCustomerQueryVariables>(ExistingCustomerDocument, baseOptions);
        }
export type ExistingCustomerQueryHookResult = ReturnType<typeof useExistingCustomerQuery>;
export type ExistingCustomerLazyQueryHookResult = ReturnType<typeof useExistingCustomerLazyQuery>;
export type ExistingCustomerQueryResult = Apollo.QueryResult<ExistingCustomerQuery, ExistingCustomerQueryVariables>;
export const UserCouponDocument = gql`
    query UserCoupon {
  cart {
    id
    userCoupon {
      coupon {
        code
      }
      notices {
        ...NoticeData
      }
    }
    orderSummary {
      id
      totalSaving {
        amount
      }
    }
  }
}
    ${NoticeDataFragmentDoc}`;

/**
 * __useUserCouponQuery__
 *
 * To run a query within a React component, call `useUserCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCouponQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCouponQuery(baseOptions?: Apollo.QueryHookOptions<UserCouponQuery, UserCouponQueryVariables>) {
        return Apollo.useQuery<UserCouponQuery, UserCouponQueryVariables>(UserCouponDocument, baseOptions);
      }
export function useUserCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCouponQuery, UserCouponQueryVariables>) {
          return Apollo.useLazyQuery<UserCouponQuery, UserCouponQueryVariables>(UserCouponDocument, baseOptions);
        }
export type UserCouponQueryHookResult = ReturnType<typeof useUserCouponQuery>;
export type UserCouponLazyQueryHookResult = ReturnType<typeof useUserCouponLazyQuery>;
export type UserCouponQueryResult = Apollo.QueryResult<UserCouponQuery, UserCouponQueryVariables>;
export const UpdateCartCouponDocument = gql`
    mutation UpdateCartCoupon($code: String!) {
  updateCartCoupon(input: {code: $code}) {
    ... on Cart {
      id
      notices {
        ...NoticeData
      }
      orderSummary {
        ...OrderSummaryData
      }
      userCoupon {
        coupon {
          code
        }
      }
    }
    ... on UserError {
      message
    }
    ... on UnauthorisedUserError {
      messageOverride {
        template
        placeholders {
          id
          text
          url
        }
        default
      }
    }
  }
}
    ${NoticeDataFragmentDoc}
${OrderSummaryDataFragmentDoc}`;
export type UpdateCartCouponMutationFn = Apollo.MutationFunction<UpdateCartCouponMutation, UpdateCartCouponMutationVariables>;

/**
 * __useUpdateCartCouponMutation__
 *
 * To run a mutation, you first call `useUpdateCartCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartCouponMutation, { data, loading, error }] = useUpdateCartCouponMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUpdateCartCouponMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartCouponMutation, UpdateCartCouponMutationVariables>) {
        return Apollo.useMutation<UpdateCartCouponMutation, UpdateCartCouponMutationVariables>(UpdateCartCouponDocument, baseOptions);
      }
export type UpdateCartCouponMutationHookResult = ReturnType<typeof useUpdateCartCouponMutation>;
export type UpdateCartCouponMutationResult = Apollo.MutationResult<UpdateCartCouponMutation>;
export type UpdateCartCouponMutationOptions = Apollo.BaseMutationOptions<UpdateCartCouponMutation, UpdateCartCouponMutationVariables>;
export const ToggleDonationDocument = gql`
    mutation ToggleDonation($add: Boolean!) {
  toggleDonation(input: {addDonation: $add}) {
    ... on Error {
      message
    }
    ... on Cart {
      orderSummary {
        ...OrderSummaryData
      }
    }
  }
}
    ${OrderSummaryDataFragmentDoc}`;
export type ToggleDonationMutationFn = Apollo.MutationFunction<ToggleDonationMutation, ToggleDonationMutationVariables>;

/**
 * __useToggleDonationMutation__
 *
 * To run a mutation, you first call `useToggleDonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDonationMutation, { data, loading, error }] = useToggleDonationMutation({
 *   variables: {
 *      add: // value for 'add'
 *   },
 * });
 */
export function useToggleDonationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleDonationMutation, ToggleDonationMutationVariables>) {
        return Apollo.useMutation<ToggleDonationMutation, ToggleDonationMutationVariables>(ToggleDonationDocument, baseOptions);
      }
export type ToggleDonationMutationHookResult = ReturnType<typeof useToggleDonationMutation>;
export type ToggleDonationMutationResult = Apollo.MutationResult<ToggleDonationMutation>;
export type ToggleDonationMutationOptions = Apollo.BaseMutationOptions<ToggleDonationMutation, ToggleDonationMutationVariables>;
export const RedeemGiftCardDocument = gql`
    mutation RedeemGiftCard($giftCard: RedeemGiftCardInput!) {
  redeemGiftCard(input: $giftCard) {
    __typename
    ... on Cart {
      notices {
        ...NoticeData
      }
      orderSummary {
        ...OrderSummaryData
      }
    }
    ... on Error {
      message
    }
  }
}
    ${NoticeDataFragmentDoc}
${OrderSummaryDataFragmentDoc}`;
export type RedeemGiftCardMutationFn = Apollo.MutationFunction<RedeemGiftCardMutation, RedeemGiftCardMutationVariables>;

/**
 * __useRedeemGiftCardMutation__
 *
 * To run a mutation, you first call `useRedeemGiftCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemGiftCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemGiftCardMutation, { data, loading, error }] = useRedeemGiftCardMutation({
 *   variables: {
 *      giftCard: // value for 'giftCard'
 *   },
 * });
 */
export function useRedeemGiftCardMutation(baseOptions?: Apollo.MutationHookOptions<RedeemGiftCardMutation, RedeemGiftCardMutationVariables>) {
        return Apollo.useMutation<RedeemGiftCardMutation, RedeemGiftCardMutationVariables>(RedeemGiftCardDocument, baseOptions);
      }
export type RedeemGiftCardMutationHookResult = ReturnType<typeof useRedeemGiftCardMutation>;
export type RedeemGiftCardMutationResult = Apollo.MutationResult<RedeemGiftCardMutation>;
export type RedeemGiftCardMutationOptions = Apollo.BaseMutationOptions<RedeemGiftCardMutation, RedeemGiftCardMutationVariables>;
export const OrderSummaryDocument = gql`
    query OrderSummary {
  cart {
    id
    itemsQuantitySum
    parcels {
      id
    }
    orderSummary {
      ...OrderSummaryData
    }
    clubSubscription {
      selectedOption {
        id
        price {
          amount
        }
      }
    }
    canProceedToCheckout
    giftCardSupported
  }
}
    ${OrderSummaryDataFragmentDoc}`;

/**
 * __useOrderSummaryQuery__
 *
 * To run a query within a React component, call `useOrderSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderSummaryQuery(baseOptions?: Apollo.QueryHookOptions<OrderSummaryQuery, OrderSummaryQueryVariables>) {
        return Apollo.useQuery<OrderSummaryQuery, OrderSummaryQueryVariables>(OrderSummaryDocument, baseOptions);
      }
export function useOrderSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderSummaryQuery, OrderSummaryQueryVariables>) {
          return Apollo.useLazyQuery<OrderSummaryQuery, OrderSummaryQueryVariables>(OrderSummaryDocument, baseOptions);
        }
export type OrderSummaryQueryHookResult = ReturnType<typeof useOrderSummaryQuery>;
export type OrderSummaryLazyQueryHookResult = ReturnType<typeof useOrderSummaryLazyQuery>;
export type OrderSummaryQueryResult = Apollo.QueryResult<OrderSummaryQuery, OrderSummaryQueryVariables>;
export const RemoveCouponFromCartDocument = gql`
    mutation RemoveCouponFromCart {
  removeCouponFromCart {
    ... on Cart {
      id
      notices {
        ...NoticeData
      }
      orderSummary {
        ...OrderSummaryData
      }
      userCoupon {
        coupon {
          code
        }
      }
    }
    ... on UserError {
      message
    }
  }
}
    ${NoticeDataFragmentDoc}
${OrderSummaryDataFragmentDoc}`;
export type RemoveCouponFromCartMutationFn = Apollo.MutationFunction<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>;

/**
 * __useRemoveCouponFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveCouponFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCouponFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCouponFromCartMutation, { data, loading, error }] = useRemoveCouponFromCartMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveCouponFromCartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>) {
        return Apollo.useMutation<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>(RemoveCouponFromCartDocument, baseOptions);
      }
export type RemoveCouponFromCartMutationHookResult = ReturnType<typeof useRemoveCouponFromCartMutation>;
export type RemoveCouponFromCartMutationResult = Apollo.MutationResult<RemoveCouponFromCartMutation>;
export type RemoveCouponFromCartMutationOptions = Apollo.BaseMutationOptions<RemoveCouponFromCartMutation, RemoveCouponFromCartMutationVariables>;
export const RemoveGiftCardFromCartDocument = gql`
    mutation RemoveGiftCardFromCart($giftCardCode: String!) {
  removeGiftCardFromCart(input: {code: $giftCardCode}) {
    __typename
    ... on Cart {
      id
      notices {
        ...NoticeData
      }
      orderSummary {
        ...OrderSummaryData
      }
    }
    ... on Error {
      message
    }
  }
}
    ${NoticeDataFragmentDoc}
${OrderSummaryDataFragmentDoc}`;
export type RemoveGiftCardFromCartMutationFn = Apollo.MutationFunction<RemoveGiftCardFromCartMutation, RemoveGiftCardFromCartMutationVariables>;

/**
 * __useRemoveGiftCardFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveGiftCardFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGiftCardFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGiftCardFromCartMutation, { data, loading, error }] = useRemoveGiftCardFromCartMutation({
 *   variables: {
 *      giftCardCode: // value for 'giftCardCode'
 *   },
 * });
 */
export function useRemoveGiftCardFromCartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGiftCardFromCartMutation, RemoveGiftCardFromCartMutationVariables>) {
        return Apollo.useMutation<RemoveGiftCardFromCartMutation, RemoveGiftCardFromCartMutationVariables>(RemoveGiftCardFromCartDocument, baseOptions);
      }
export type RemoveGiftCardFromCartMutationHookResult = ReturnType<typeof useRemoveGiftCardFromCartMutation>;
export type RemoveGiftCardFromCartMutationResult = Apollo.MutationResult<RemoveGiftCardFromCartMutation>;
export type RemoveGiftCardFromCartMutationOptions = Apollo.BaseMutationOptions<RemoveGiftCardFromCartMutation, RemoveGiftCardFromCartMutationVariables>;
export const GetLocationSuggestionsDocument = gql`
    query GetLocationSuggestions($searchTerm: String, $postcode: String, $suburb: String) {
  locationSuggestions(input: {postcode: $postcode, suburb: $suburb, searchParameters: {searchTerm: $searchTerm}}) {
    postcodes {
      id
      postcode
      suburb
      state
      country
    }
  }
}
    `;

/**
 * __useGetLocationSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetLocationSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationSuggestionsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      postcode: // value for 'postcode'
 *      suburb: // value for 'suburb'
 *   },
 * });
 */
export function useGetLocationSuggestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationSuggestionsQuery, GetLocationSuggestionsQueryVariables>) {
        return Apollo.useQuery<GetLocationSuggestionsQuery, GetLocationSuggestionsQueryVariables>(GetLocationSuggestionsDocument, baseOptions);
      }
export function useGetLocationSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationSuggestionsQuery, GetLocationSuggestionsQueryVariables>) {
          return Apollo.useLazyQuery<GetLocationSuggestionsQuery, GetLocationSuggestionsQueryVariables>(GetLocationSuggestionsDocument, baseOptions);
        }
export type GetLocationSuggestionsQueryHookResult = ReturnType<typeof useGetLocationSuggestionsQuery>;
export type GetLocationSuggestionsLazyQueryHookResult = ReturnType<typeof useGetLocationSuggestionsLazyQuery>;
export type GetLocationSuggestionsQueryResult = Apollo.QueryResult<GetLocationSuggestionsQuery, GetLocationSuggestionsQueryVariables>;
export const UpdateCartLocationDocument = gql`
    mutation UpdateCartLocation($locationId: Int!) {
  updateCartLocation(input: {locationId: $locationId}) {
    ... on Cart {
      ...CartData
    }
    ... on UserError {
      message
    }
  }
}
    ${CartDataFragmentDoc}`;
export type UpdateCartLocationMutationFn = Apollo.MutationFunction<UpdateCartLocationMutation, UpdateCartLocationMutationVariables>;

/**
 * __useUpdateCartLocationMutation__
 *
 * To run a mutation, you first call `useUpdateCartLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartLocationMutation, { data, loading, error }] = useUpdateCartLocationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useUpdateCartLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartLocationMutation, UpdateCartLocationMutationVariables>) {
        return Apollo.useMutation<UpdateCartLocationMutation, UpdateCartLocationMutationVariables>(UpdateCartLocationDocument, baseOptions);
      }
export type UpdateCartLocationMutationHookResult = ReturnType<typeof useUpdateCartLocationMutation>;
export type UpdateCartLocationMutationResult = Apollo.MutationResult<UpdateCartLocationMutation>;
export type UpdateCartLocationMutationOptions = Apollo.BaseMutationOptions<UpdateCartLocationMutation, UpdateCartLocationMutationVariables>;